// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-primary-dark {
  color: #1B1E26;
}

.color-aqua-green {
  color: #3BCFB2;
}

.color-green {
  color: #29694F;
}

.color-green-dark {
  color: #2A624A;
}

.color-green-light {
  color: #579A6E;
}

.color-purple {
  color: #292F69;
}

.color-red {
  color: #692929;
}

.color-red-light {
  color: #D0021B;
}

.color-orange {
  color: #DD5944;
}

.color-blue {
  color: #294369;
}

.color-blue-grey {
  color: #294369;
}

.color-blue-2 {
  color: #3165B2;
}

.color-yellow {
  color: #19160C;
}

.color-gray {
  color: rgba(141, 141, 141, 0.85);
}

.color-light-green {
  color: #71C187;
}

.color-pink {
  color: #572969;
}

.color-blue-high {
  color: #F6FAFE;
}

.color-blue-2-high {
  color: #F6FAFE;
}

:root {
  /* Primary colors */
  --primary-color-100: #779BB0;
  --primary-color-300: #454B56;
  --primary-color-400: #294369;
  --primary-color-500: #152935;
  --primary-color-500-50: #2e5c9a80;
  --primary-color-600: #1c1f27;
  --primary-color-650: #1b1e26;
  --primary-color-700: #1a2634;
  --secondary-color-500: #006cff;
  --rs-gray-0: #fff;
  --rs-gray-50: #f7f7fa;
  --rs-gray-100: var(--primary-color-dark-100);
  --rs-gray-200: var(--primary-color-dark-200);
  --rs-gray-300: var(--primary-color-dark-300);
  --rs-gray-400: var(--primary-color-dark-400);
  --rs-gray-500: var(--primary-color-dark-500);
  --rs-gray-600: var(--primary-color-dark-600);
  --rs-gray-700: var(--primary-color-dark-700);
  --rs-gray-800: var(--primary-color-dark-800);
  --rs-gray-900: var(--primary-color-700);
  --rs-primary-50: #f2faff;
  --rs-primary-100: var(--primary-color-dark-100);
  --rs-primary-200: var(--primary-color-dark-200);
  --rs-primary-400: var(--primary-color-400);
  --rs-primary-500: var(--primary-color-500);
  --rs-primary-600: var(--primary-color-600);
  --rs-primary-700: var(--primary-color-700);
  --rs-primary-800: var(--primary-color-dark-800);
  --rs-primary-900: var(--primary-color-dark-900);
  --rs-bg-overlay: var(--primary-color-light-500);
  --rs-calendar-date-selected-text: var(--primary-color-light-500);
  /* Accent colors */
  --accent-color-1: #1B57D1;
  --accent-color-2: #FF832B;
  --accent-color-3: #fe7b06;
  /* Secondary colors */
  --secondary-color-300: #71C187;
  --secondary-color-300-50: #71c18780;
  /* Dark colors */
  --primary-color-dark-900: #000000;
  --primary-color-dark-850: #040D0B;
  --primary-color-dark-800: #152935;
  --primary-color-dark-750: #1C1F27;
  --primary-color-dark-720: #272727;
  --primary-color-dark-700: #353333;
  --primary-color-dark-650: #383c42;
  --primary-color-dark-610: #393b42;
  --primary-color-dark-600: #3F4A50;
  --primary-color-dark-550: #484848;
  --primary-color-dark-500: #535353;
  --primary-color-dark-400: #646464;
  --primary-color-dark-375: #676767;
  --primary-color-dark-350: #736F6F;
  --primary-color-dark-300: #818078;
  --primary-color-dark-200: #AAAAAA;
  --primary-color-dark-100: #BCBCBC;
  /* Light colors */
  --primary-color-light-500: #FFFFFF;
  --primary-color-light-300: #F4F4F4;
  --primary-color-light-200: #F5F5F5;
  --primary-color-light-150: #F6FAFE;
  --primary-color-light-opacity-59: rgba(255, 255, 255, .59);
  --primary-color-light-opacity-45: rgba(255, 255, 255, .45);
  --primary-color-light-opacity-2: rgba(255, 255, 255, .2);
  /* Alert and danger colors */
  --alert-color-1: #DA1E28;
  --alert-color-2: #24A148;
  --alert-color-3: #4a944f;
  --warning-color-1: #f1c755;
  --danger-color-300: #C17D71;
  --danger-color-500: #D7563F;
  /* Brand colors */
  --facebook-brand-color: #1A77F3;
  --linkedin-brand-color: #007DBB;
  --twitter-brand-color: #03A9F4;
  /* Box shadows */
  --box-shadow-primary-5: rgba(0, 0, 0, 0.5);
  --box-shadow-primary-7: rgba(0, 0, 0, 0.07);
  --box-shadow-primary-12: rgba(0, 0, 0, 0.12);
  --box-shadow-primary-13: rgba(0, 0, 0, 0.13);
  --box-shadow-primary-14: rgba(0, 0, 0, 0.14);
  --box-shadow-primary-16: rgba(0, 0, 0, 0.16);
  --box-shadow-primary-18: rgba(0, 0, 0, 0.18);
  --box-shadow-primary-19: rgba(0, 0, 0, 0.19);
  --box-shadow-primary-22: rgba(0, 0, 0, 0.22);
  --box-shadow-primary-25: rgba(0, 0, 0, 0.25);
  --box-shadow-primary-57: rgba(0, 0, 0, 0.57);
  /* Card shadows */
  --card-view-box-shadow: 0 2px 6px 0 rgba(109, 109, 109, 0.08);
  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(109, 109, 109, 0.5);
  --card-view-box-shadow-light: -1px 1px 8px rgba(0, 0, 0, 0.11);
  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(0, 0, 0, 0.28);
  --z-index-close: -1;
  --z-index-popup: 12;
  --z-index-tooltip: 11;
  --z-index-popup-light: 10;
  --z-index-sticky: 9;
}

/* Dark Theme - Reversed/Adapted Colors */
:root[data-theme=dark] {
  /* Primary colors - Reversed for dark theme */
  --primary-color-100: #BCBCBC; /* Was #779BB0 - now light grey */
  --primary-color-300: #AAAAAA; /* Was #454B56 - now medium grey */
  --primary-color-400: #779BB0; /* Was #294369 - now original 100 */
  --primary-color-500: #FFFFFF; /* Was #152935 - now white for text */
  --primary-color-500-50: rgba(188, 188, 188, 0.5); /* Adapted opacity */
  --primary-color-600: #F4F4F4; /* Was #1c1f27 - now light */
  --primary-color-650: #F5F5F5; /* Was #1b1e26 - now light */
  --primary-color-700: #F6FAFE; /* Was #1a2634 - now lightest */
  /* Mirror rs- (design-system) variables for dark theme so overrides
     in :root are reversed appropriately in dark mode. These reference
     the dark-theme primary/light variables defined above. */
  --rs-gray-0: var(--primary-color-light-500);
  --rs-gray-50: var(--primary-color-light-300);
  --rs-gray-100: var(--primary-color-dark-100);
  --rs-gray-200: var(--primary-color-dark-200);
  --rs-gray-300: var(--primary-color-dark-300);
  --rs-gray-400: var(--primary-color-dark-400);
  --rs-gray-500: var(--primary-color-dark-500);
  --rs-gray-600: var(--primary-color-dark-600);
  --rs-gray-700: var(--primary-color-dark-700);
  --rs-gray-800: var(--primary-color-dark-800);
  --rs-gray-900: var(--primary-color-700);
  --rs-primary-50: var(--primary-color-light-150);
  --rs-primary-100: var(--primary-color-dark-100);
  --rs-primary-200: var(--primary-color-dark-200);
  --rs-primary-400: var(--primary-color-400);
  --rs-primary-500: var(--primary-color-500);
  --rs-primary-600: var(--primary-color-600);
  --rs-primary-700: var(--primary-color-700);
  --rs-primary-800: var(--primary-color-dark-800);
  --rs-primary-900: var(--primary-color-dark-900);
  --rs-bg-overlay: var(--primary-color-light-500);
  --rs-calendar-date-selected-text: var(--primary-color-light-500);
  /* Accent colors - Brightened for dark backgrounds */
  --accent-color-1: #4A7FE7; /* Lightened blue */
  --accent-color-2: #FF9A4D; /* Lightened orange */
  --accent-color-3: #FF8C2B; /* Lightened orange variant */
  --secondary-color-500: #006cff;
  --secondary-color-300: #8FD4A4; /* Lightened green */
  --secondary-color-300-50: rgba(143, 212, 164, 0.5);
  /* Dark colors become background/surface colors */
  --primary-color-dark-900: #FFFFFF; /* Reversed - now white */
  --primary-color-dark-850: #F6FAFE; /* Light background */
  --primary-color-dark-800: #F5F5F5; /* Light surface */
  --primary-color-dark-750: #F4F4F4; /* Light elevated */
  --primary-color-dark-720: #EEEEEE; /* Light hover */
  --primary-color-dark-700: #E8E8E8; /* Light active */
  --primary-color-dark-650: #E0E0E0; /* Light border */
  --primary-color-dark-610: #DDDDDD; /* Light border variant */
  --primary-color-dark-600: #D8D8D8; /* Light subtle */
  --primary-color-dark-550: #CCCCCC; /* Medium light */
  --primary-color-dark-500: #BBBBBB; /* Medium */
  --primary-color-dark-400: #AAAAAA; /* Medium dark */
  --primary-color-dark-375: #999999; /* Medium dark variant */
  --primary-color-dark-350: #888888; /* Dark */
  --primary-color-dark-300: #777777; /* Darker */
  --primary-color-dark-200: #555555; /* Very dark */
  --primary-color-dark-100: #454B56; /* Darkest - original 300 */
  /* Light colors become dark backgrounds */
  --primary-color-light-500: #000000; /* Main dark background */
  --primary-color-light-300: #040D0B; /* Dark secondary */
  --primary-color-light-200: #152935; /* Dark tertiary */
  --primary-color-light-150: #1C1F27; /* Dark elevated */
  --primary-color-light-opacity-59: rgba(0, 0, 0, 0.59);
  --primary-color-light-opacity-45: rgba(0, 0, 0, 0.45);
  --primary-color-light-opacity-2: rgba(0, 0, 0, 0.2);
  /* Alert and danger colors - Enhanced for dark */
  --alert-color-1: #FF4757; /* Brighter red */
  --alert-color-2: #2ECC71; /* Brighter green */
  --alert-color-3: #27AE60; /* Brighter green variant */
  --warning-color-1: #F39C12; /* Brighter yellow */
  --danger-color-300: #E74C3C; /* Brighter danger */
  --danger-color-500: #C0392B; /* Darker danger */
  /* Brand colors - Lightened for dark backgrounds */
  --facebook-brand-color: #4267B2;
  --linkedin-brand-color: #0077B5;
  --twitter-brand-color: #1DA1F2;
  /* Box shadows - Adapted for dark theme */
  --box-shadow-primary-5: rgba(255, 255, 255, 0.1);
  --box-shadow-primary-7: rgba(255, 255, 255, 0.07);
  --box-shadow-primary-12: rgba(255, 255, 255, 0.12);
  --box-shadow-primary-13: rgba(255, 255, 255, 0.13);
  --box-shadow-primary-14: rgba(255, 255, 255, 0.14);
  --box-shadow-primary-16: rgba(255, 255, 255, 0.16);
  --box-shadow-primary-18: rgba(255, 255, 255, 0.18);
  --box-shadow-primary-19: rgba(255, 255, 255, 0.19);
  --box-shadow-primary-22: rgba(255, 255, 255, 0.22);
  --box-shadow-primary-25: rgba(255, 255, 255, 0.25);
  --box-shadow-primary-57: rgba(255, 255, 255, 0.1);
  /* Card shadows - Dark theme */
  --card-view-box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0.08);
  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(255, 255, 255, 0.15);
  --card-view-box-shadow-light: -1px 1px 8px rgba(255, 255, 255, 0.11);
  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(255, 255, 255, 0.25);
  --z-index-popup: 10;
  --z-index-sticky: 9;
}

.color-primary {
  color: #152935;
}

.color-primary-700 {
  color: #1a2634;
}

.padding-l-0 {
  padding-left: 0px;
}

.padding-l-1 {
  padding-left: 1px;
}

.padding-l-2 {
  padding-left: 2px;
}

.padding-l-3 {
  padding-left: 3px;
}

.padding-l-4 {
  padding-left: 4px;
}

.padding-l-5 {
  padding-left: 5px;
}

.padding-l-6 {
  padding-left: 6px;
}

.padding-l-7 {
  padding-left: 7px;
}

.padding-l-8 {
  padding-left: 8px;
}

.padding-l-9 {
  padding-left: 9px;
}

.padding-l-10 {
  padding-left: 10px;
}

.padding-l-11 {
  padding-left: 11px;
}

.padding-l-12 {
  padding-left: 12px;
}

.padding-l-13 {
  padding-left: 13px;
}

.padding-l-14 {
  padding-left: 14px;
}

.padding-l-15 {
  padding-left: 15px;
}

.padding-l-16 {
  padding-left: 16px;
}

.padding-l-17 {
  padding-left: 17px;
}

.padding-l-18 {
  padding-left: 18px;
}

.padding-l-19 {
  padding-left: 19px;
}

.padding-l-20 {
  padding-left: 20px;
}

.padding-l-21 {
  padding-left: 21px;
}

.padding-l-22 {
  padding-left: 22px;
}

.padding-l-23 {
  padding-left: 23px;
}

.padding-l-24 {
  padding-left: 24px;
}

.padding-l-25 {
  padding-left: 25px;
}

.padding-l-26 {
  padding-left: 26px;
}

.padding-l-27 {
  padding-left: 27px;
}

.padding-l-28 {
  padding-left: 28px;
}

.padding-l-29 {
  padding-left: 29px;
}

.padding-l-30 {
  padding-left: 30px;
}

.padding-l-31 {
  padding-left: 31px;
}

.padding-l-32 {
  padding-left: 32px;
}

.padding-l-33 {
  padding-left: 33px;
}

.padding-l-34 {
  padding-left: 34px;
}

.padding-l-35 {
  padding-left: 35px;
}

.padding-l-36 {
  padding-left: 36px;
}

.padding-l-37 {
  padding-left: 37px;
}

.padding-l-38 {
  padding-left: 38px;
}

.padding-l-39 {
  padding-left: 39px;
}

.padding-l-40 {
  padding-left: 40px;
}

.padding-l-41 {
  padding-left: 41px;
}

.padding-l-42 {
  padding-left: 42px;
}

.padding-l-43 {
  padding-left: 43px;
}

.padding-l-44 {
  padding-left: 44px;
}

.padding-l-45 {
  padding-left: 45px;
}

.padding-l-46 {
  padding-left: 46px;
}

.padding-l-47 {
  padding-left: 47px;
}

.padding-l-48 {
  padding-left: 48px;
}

.padding-l-49 {
  padding-left: 49px;
}

.padding-l-50 {
  padding-left: 50px;
}

.padding-l-51 {
  padding-left: 51px;
}

.padding-l-52 {
  padding-left: 52px;
}

.padding-l-53 {
  padding-left: 53px;
}

.padding-l-54 {
  padding-left: 54px;
}

.padding-l-55 {
  padding-left: 55px;
}

.padding-l-56 {
  padding-left: 56px;
}

.padding-l-57 {
  padding-left: 57px;
}

.padding-l-58 {
  padding-left: 58px;
}

.padding-l-59 {
  padding-left: 59px;
}

.padding-l-60 {
  padding-left: 60px;
}

.padding-l-61 {
  padding-left: 61px;
}

.padding-l-62 {
  padding-left: 62px;
}

.padding-l-63 {
  padding-left: 63px;
}

.padding-l-64 {
  padding-left: 64px;
}

.padding-l-65 {
  padding-left: 65px;
}

.padding-l-66 {
  padding-left: 66px;
}

.padding-l-67 {
  padding-left: 67px;
}

.padding-l-68 {
  padding-left: 68px;
}

.padding-l-69 {
  padding-left: 69px;
}

.padding-l-70 {
  padding-left: 70px;
}

.padding-l-71 {
  padding-left: 71px;
}

.padding-l-72 {
  padding-left: 72px;
}

.padding-l-73 {
  padding-left: 73px;
}

.padding-l-74 {
  padding-left: 74px;
}

.padding-l-75 {
  padding-left: 75px;
}

.padding-l-76 {
  padding-left: 76px;
}

.padding-l-77 {
  padding-left: 77px;
}

.padding-l-78 {
  padding-left: 78px;
}

.padding-l-79 {
  padding-left: 79px;
}

.padding-l-80 {
  padding-left: 80px;
}

.padding-l-81 {
  padding-left: 81px;
}

.padding-l-82 {
  padding-left: 82px;
}

.padding-l-83 {
  padding-left: 83px;
}

.padding-l-84 {
  padding-left: 84px;
}

.padding-l-85 {
  padding-left: 85px;
}

.padding-l-86 {
  padding-left: 86px;
}

.padding-l-87 {
  padding-left: 87px;
}

.padding-l-88 {
  padding-left: 88px;
}

.padding-l-89 {
  padding-left: 89px;
}

.padding-l-90 {
  padding-left: 90px;
}

.padding-l-91 {
  padding-left: 91px;
}

.padding-l-92 {
  padding-left: 92px;
}

.padding-l-93 {
  padding-left: 93px;
}

.padding-l-94 {
  padding-left: 94px;
}

.padding-l-95 {
  padding-left: 95px;
}

.padding-l-96 {
  padding-left: 96px;
}

.padding-l-97 {
  padding-left: 97px;
}

.padding-l-98 {
  padding-left: 98px;
}

.padding-l-99 {
  padding-left: 99px;
}

.padding-l-100 {
  padding-left: 100px;
}

.padding-r-0 {
  padding-right: 0px;
}

.padding-r-1 {
  padding-right: 1px;
}

.padding-r-2 {
  padding-right: 2px;
}

.padding-r-3 {
  padding-right: 3px;
}

.padding-r-4 {
  padding-right: 4px;
}

.padding-r-5 {
  padding-right: 5px;
}

.padding-r-6 {
  padding-right: 6px;
}

.padding-r-7 {
  padding-right: 7px;
}

.padding-r-8 {
  padding-right: 8px;
}

.padding-r-9 {
  padding-right: 9px;
}

.padding-r-10 {
  padding-right: 10px;
}

.padding-r-11 {
  padding-right: 11px;
}

.padding-r-12 {
  padding-right: 12px;
}

.padding-r-13 {
  padding-right: 13px;
}

.padding-r-14 {
  padding-right: 14px;
}

.padding-r-15 {
  padding-right: 15px;
}

.padding-r-16 {
  padding-right: 16px;
}

.padding-r-17 {
  padding-right: 17px;
}

.padding-r-18 {
  padding-right: 18px;
}

.padding-r-19 {
  padding-right: 19px;
}

.padding-r-20 {
  padding-right: 20px;
}

.padding-r-21 {
  padding-right: 21px;
}

.padding-r-22 {
  padding-right: 22px;
}

.padding-r-23 {
  padding-right: 23px;
}

.padding-r-24 {
  padding-right: 24px;
}

.padding-r-25 {
  padding-right: 25px;
}

.padding-r-26 {
  padding-right: 26px;
}

.padding-r-27 {
  padding-right: 27px;
}

.padding-r-28 {
  padding-right: 28px;
}

.padding-r-29 {
  padding-right: 29px;
}

.padding-r-30 {
  padding-right: 30px;
}

.padding-r-31 {
  padding-right: 31px;
}

.padding-r-32 {
  padding-right: 32px;
}

.padding-r-33 {
  padding-right: 33px;
}

.padding-r-34 {
  padding-right: 34px;
}

.padding-r-35 {
  padding-right: 35px;
}

.padding-r-36 {
  padding-right: 36px;
}

.padding-r-37 {
  padding-right: 37px;
}

.padding-r-38 {
  padding-right: 38px;
}

.padding-r-39 {
  padding-right: 39px;
}

.padding-r-40 {
  padding-right: 40px;
}

.padding-r-41 {
  padding-right: 41px;
}

.padding-r-42 {
  padding-right: 42px;
}

.padding-r-43 {
  padding-right: 43px;
}

.padding-r-44 {
  padding-right: 44px;
}

.padding-r-45 {
  padding-right: 45px;
}

.padding-r-46 {
  padding-right: 46px;
}

.padding-r-47 {
  padding-right: 47px;
}

.padding-r-48 {
  padding-right: 48px;
}

.padding-r-49 {
  padding-right: 49px;
}

.padding-r-50 {
  padding-right: 50px;
}

.padding-r-51 {
  padding-right: 51px;
}

.padding-r-52 {
  padding-right: 52px;
}

.padding-r-53 {
  padding-right: 53px;
}

.padding-r-54 {
  padding-right: 54px;
}

.padding-r-55 {
  padding-right: 55px;
}

.padding-r-56 {
  padding-right: 56px;
}

.padding-r-57 {
  padding-right: 57px;
}

.padding-r-58 {
  padding-right: 58px;
}

.padding-r-59 {
  padding-right: 59px;
}

.padding-r-60 {
  padding-right: 60px;
}

.padding-r-61 {
  padding-right: 61px;
}

.padding-r-62 {
  padding-right: 62px;
}

.padding-r-63 {
  padding-right: 63px;
}

.padding-r-64 {
  padding-right: 64px;
}

.padding-r-65 {
  padding-right: 65px;
}

.padding-r-66 {
  padding-right: 66px;
}

.padding-r-67 {
  padding-right: 67px;
}

.padding-r-68 {
  padding-right: 68px;
}

.padding-r-69 {
  padding-right: 69px;
}

.padding-r-70 {
  padding-right: 70px;
}

.padding-r-71 {
  padding-right: 71px;
}

.padding-r-72 {
  padding-right: 72px;
}

.padding-r-73 {
  padding-right: 73px;
}

.padding-r-74 {
  padding-right: 74px;
}

.padding-r-75 {
  padding-right: 75px;
}

.padding-r-76 {
  padding-right: 76px;
}

.padding-r-77 {
  padding-right: 77px;
}

.padding-r-78 {
  padding-right: 78px;
}

.padding-r-79 {
  padding-right: 79px;
}

.padding-r-80 {
  padding-right: 80px;
}

.padding-r-81 {
  padding-right: 81px;
}

.padding-r-82 {
  padding-right: 82px;
}

.padding-r-83 {
  padding-right: 83px;
}

.padding-r-84 {
  padding-right: 84px;
}

.padding-r-85 {
  padding-right: 85px;
}

.padding-r-86 {
  padding-right: 86px;
}

.padding-r-87 {
  padding-right: 87px;
}

.padding-r-88 {
  padding-right: 88px;
}

.padding-r-89 {
  padding-right: 89px;
}

.padding-r-90 {
  padding-right: 90px;
}

.padding-r-91 {
  padding-right: 91px;
}

.padding-r-92 {
  padding-right: 92px;
}

.padding-r-93 {
  padding-right: 93px;
}

.padding-r-94 {
  padding-right: 94px;
}

.padding-r-95 {
  padding-right: 95px;
}

.padding-r-96 {
  padding-right: 96px;
}

.padding-r-97 {
  padding-right: 97px;
}

.padding-r-98 {
  padding-right: 98px;
}

.padding-r-99 {
  padding-right: 99px;
}

.padding-r-100 {
  padding-right: 100px;
}

.padding-b-0 {
  padding-bottom: 0px;
}

.padding-b-1 {
  padding-bottom: 1px;
}

.padding-b-2 {
  padding-bottom: 2px;
}

.padding-b-3 {
  padding-bottom: 3px;
}

.padding-b-4 {
  padding-bottom: 4px;
}

.padding-b-5 {
  padding-bottom: 5px;
}

.padding-b-6 {
  padding-bottom: 6px;
}

.padding-b-7 {
  padding-bottom: 7px;
}

.padding-b-8 {
  padding-bottom: 8px;
}

.padding-b-9 {
  padding-bottom: 9px;
}

.padding-b-10 {
  padding-bottom: 10px;
}

.padding-b-11 {
  padding-bottom: 11px;
}

.padding-b-12 {
  padding-bottom: 12px;
}

.padding-b-13 {
  padding-bottom: 13px;
}

.padding-b-14 {
  padding-bottom: 14px;
}

.padding-b-15 {
  padding-bottom: 15px;
}

.padding-b-16 {
  padding-bottom: 16px;
}

.padding-b-17 {
  padding-bottom: 17px;
}

.padding-b-18 {
  padding-bottom: 18px;
}

.padding-b-19 {
  padding-bottom: 19px;
}

.padding-b-20 {
  padding-bottom: 20px;
}

.padding-b-21 {
  padding-bottom: 21px;
}

.padding-b-22 {
  padding-bottom: 22px;
}

.padding-b-23 {
  padding-bottom: 23px;
}

.padding-b-24 {
  padding-bottom: 24px;
}

.padding-b-25 {
  padding-bottom: 25px;
}

.padding-b-26 {
  padding-bottom: 26px;
}

.padding-b-27 {
  padding-bottom: 27px;
}

.padding-b-28 {
  padding-bottom: 28px;
}

.padding-b-29 {
  padding-bottom: 29px;
}

.padding-b-30 {
  padding-bottom: 30px;
}

.padding-b-31 {
  padding-bottom: 31px;
}

.padding-b-32 {
  padding-bottom: 32px;
}

.padding-b-33 {
  padding-bottom: 33px;
}

.padding-b-34 {
  padding-bottom: 34px;
}

.padding-b-35 {
  padding-bottom: 35px;
}

.padding-b-36 {
  padding-bottom: 36px;
}

.padding-b-37 {
  padding-bottom: 37px;
}

.padding-b-38 {
  padding-bottom: 38px;
}

.padding-b-39 {
  padding-bottom: 39px;
}

.padding-b-40 {
  padding-bottom: 40px;
}

.padding-b-41 {
  padding-bottom: 41px;
}

.padding-b-42 {
  padding-bottom: 42px;
}

.padding-b-43 {
  padding-bottom: 43px;
}

.padding-b-44 {
  padding-bottom: 44px;
}

.padding-b-45 {
  padding-bottom: 45px;
}

.padding-b-46 {
  padding-bottom: 46px;
}

.padding-b-47 {
  padding-bottom: 47px;
}

.padding-b-48 {
  padding-bottom: 48px;
}

.padding-b-49 {
  padding-bottom: 49px;
}

.padding-b-50 {
  padding-bottom: 50px;
}

.padding-b-51 {
  padding-bottom: 51px;
}

.padding-b-52 {
  padding-bottom: 52px;
}

.padding-b-53 {
  padding-bottom: 53px;
}

.padding-b-54 {
  padding-bottom: 54px;
}

.padding-b-55 {
  padding-bottom: 55px;
}

.padding-b-56 {
  padding-bottom: 56px;
}

.padding-b-57 {
  padding-bottom: 57px;
}

.padding-b-58 {
  padding-bottom: 58px;
}

.padding-b-59 {
  padding-bottom: 59px;
}

.padding-b-60 {
  padding-bottom: 60px;
}

.padding-b-61 {
  padding-bottom: 61px;
}

.padding-b-62 {
  padding-bottom: 62px;
}

.padding-b-63 {
  padding-bottom: 63px;
}

.padding-b-64 {
  padding-bottom: 64px;
}

.padding-b-65 {
  padding-bottom: 65px;
}

.padding-b-66 {
  padding-bottom: 66px;
}

.padding-b-67 {
  padding-bottom: 67px;
}

.padding-b-68 {
  padding-bottom: 68px;
}

.padding-b-69 {
  padding-bottom: 69px;
}

.padding-b-70 {
  padding-bottom: 70px;
}

.padding-b-71 {
  padding-bottom: 71px;
}

.padding-b-72 {
  padding-bottom: 72px;
}

.padding-b-73 {
  padding-bottom: 73px;
}

.padding-b-74 {
  padding-bottom: 74px;
}

.padding-b-75 {
  padding-bottom: 75px;
}

.padding-b-76 {
  padding-bottom: 76px;
}

.padding-b-77 {
  padding-bottom: 77px;
}

.padding-b-78 {
  padding-bottom: 78px;
}

.padding-b-79 {
  padding-bottom: 79px;
}

.padding-b-80 {
  padding-bottom: 80px;
}

.padding-b-81 {
  padding-bottom: 81px;
}

.padding-b-82 {
  padding-bottom: 82px;
}

.padding-b-83 {
  padding-bottom: 83px;
}

.padding-b-84 {
  padding-bottom: 84px;
}

.padding-b-85 {
  padding-bottom: 85px;
}

.padding-b-86 {
  padding-bottom: 86px;
}

.padding-b-87 {
  padding-bottom: 87px;
}

.padding-b-88 {
  padding-bottom: 88px;
}

.padding-b-89 {
  padding-bottom: 89px;
}

.padding-b-90 {
  padding-bottom: 90px;
}

.padding-b-91 {
  padding-bottom: 91px;
}

.padding-b-92 {
  padding-bottom: 92px;
}

.padding-b-93 {
  padding-bottom: 93px;
}

.padding-b-94 {
  padding-bottom: 94px;
}

.padding-b-95 {
  padding-bottom: 95px;
}

.padding-b-96 {
  padding-bottom: 96px;
}

.padding-b-97 {
  padding-bottom: 97px;
}

.padding-b-98 {
  padding-bottom: 98px;
}

.padding-b-99 {
  padding-bottom: 99px;
}

.padding-b-100 {
  padding-bottom: 100px;
}

.padding-t-0 {
  padding-top: 0px;
}

.padding-t-1 {
  padding-top: 1px;
}

.padding-t-2 {
  padding-top: 2px;
}

.padding-t-3 {
  padding-top: 3px;
}

.padding-t-4 {
  padding-top: 4px;
}

.padding-t-5 {
  padding-top: 5px;
}

.padding-t-6 {
  padding-top: 6px;
}

.padding-t-7 {
  padding-top: 7px;
}

.padding-t-8 {
  padding-top: 8px;
}

.padding-t-9 {
  padding-top: 9px;
}

.padding-t-10 {
  padding-top: 10px;
}

.padding-t-11 {
  padding-top: 11px;
}

.padding-t-12 {
  padding-top: 12px;
}

.padding-t-13 {
  padding-top: 13px;
}

.padding-t-14 {
  padding-top: 14px;
}

.padding-t-15 {
  padding-top: 15px;
}

.padding-t-16 {
  padding-top: 16px;
}

.padding-t-17 {
  padding-top: 17px;
}

.padding-t-18 {
  padding-top: 18px;
}

.padding-t-19 {
  padding-top: 19px;
}

.padding-t-20 {
  padding-top: 20px;
}

.padding-t-21 {
  padding-top: 21px;
}

.padding-t-22 {
  padding-top: 22px;
}

.padding-t-23 {
  padding-top: 23px;
}

.padding-t-24 {
  padding-top: 24px;
}

.padding-t-25 {
  padding-top: 25px;
}

.padding-t-26 {
  padding-top: 26px;
}

.padding-t-27 {
  padding-top: 27px;
}

.padding-t-28 {
  padding-top: 28px;
}

.padding-t-29 {
  padding-top: 29px;
}

.padding-t-30 {
  padding-top: 30px;
}

.padding-t-31 {
  padding-top: 31px;
}

.padding-t-32 {
  padding-top: 32px;
}

.padding-t-33 {
  padding-top: 33px;
}

.padding-t-34 {
  padding-top: 34px;
}

.padding-t-35 {
  padding-top: 35px;
}

.padding-t-36 {
  padding-top: 36px;
}

.padding-t-37 {
  padding-top: 37px;
}

.padding-t-38 {
  padding-top: 38px;
}

.padding-t-39 {
  padding-top: 39px;
}

.padding-t-40 {
  padding-top: 40px;
}

.padding-t-41 {
  padding-top: 41px;
}

.padding-t-42 {
  padding-top: 42px;
}

.padding-t-43 {
  padding-top: 43px;
}

.padding-t-44 {
  padding-top: 44px;
}

.padding-t-45 {
  padding-top: 45px;
}

.padding-t-46 {
  padding-top: 46px;
}

.padding-t-47 {
  padding-top: 47px;
}

.padding-t-48 {
  padding-top: 48px;
}

.padding-t-49 {
  padding-top: 49px;
}

.padding-t-50 {
  padding-top: 50px;
}

.padding-t-51 {
  padding-top: 51px;
}

.padding-t-52 {
  padding-top: 52px;
}

.padding-t-53 {
  padding-top: 53px;
}

.padding-t-54 {
  padding-top: 54px;
}

.padding-t-55 {
  padding-top: 55px;
}

.padding-t-56 {
  padding-top: 56px;
}

.padding-t-57 {
  padding-top: 57px;
}

.padding-t-58 {
  padding-top: 58px;
}

.padding-t-59 {
  padding-top: 59px;
}

.padding-t-60 {
  padding-top: 60px;
}

.padding-t-61 {
  padding-top: 61px;
}

.padding-t-62 {
  padding-top: 62px;
}

.padding-t-63 {
  padding-top: 63px;
}

.padding-t-64 {
  padding-top: 64px;
}

.padding-t-65 {
  padding-top: 65px;
}

.padding-t-66 {
  padding-top: 66px;
}

.padding-t-67 {
  padding-top: 67px;
}

.padding-t-68 {
  padding-top: 68px;
}

.padding-t-69 {
  padding-top: 69px;
}

.padding-t-70 {
  padding-top: 70px;
}

.padding-t-71 {
  padding-top: 71px;
}

.padding-t-72 {
  padding-top: 72px;
}

.padding-t-73 {
  padding-top: 73px;
}

.padding-t-74 {
  padding-top: 74px;
}

.padding-t-75 {
  padding-top: 75px;
}

.padding-t-76 {
  padding-top: 76px;
}

.padding-t-77 {
  padding-top: 77px;
}

.padding-t-78 {
  padding-top: 78px;
}

.padding-t-79 {
  padding-top: 79px;
}

.padding-t-80 {
  padding-top: 80px;
}

.padding-t-81 {
  padding-top: 81px;
}

.padding-t-82 {
  padding-top: 82px;
}

.padding-t-83 {
  padding-top: 83px;
}

.padding-t-84 {
  padding-top: 84px;
}

.padding-t-85 {
  padding-top: 85px;
}

.padding-t-86 {
  padding-top: 86px;
}

.padding-t-87 {
  padding-top: 87px;
}

.padding-t-88 {
  padding-top: 88px;
}

.padding-t-89 {
  padding-top: 89px;
}

.padding-t-90 {
  padding-top: 90px;
}

.padding-t-91 {
  padding-top: 91px;
}

.padding-t-92 {
  padding-top: 92px;
}

.padding-t-93 {
  padding-top: 93px;
}

.padding-t-94 {
  padding-top: 94px;
}

.padding-t-95 {
  padding-top: 95px;
}

.padding-t-96 {
  padding-top: 96px;
}

.padding-t-97 {
  padding-top: 97px;
}

.padding-t-98 {
  padding-top: 98px;
}

.padding-t-99 {
  padding-top: 99px;
}

.padding-t-100 {
  padding-top: 100px;
}

.margin-l-0 {
  margin-left: 0px;
}

.margin-l-1 {
  margin-left: 1px;
}

.margin-l-2 {
  margin-left: 2px;
}

.margin-l-3 {
  margin-left: 3px;
}

.margin-l-4 {
  margin-left: 4px;
}

.margin-l-5 {
  margin-left: 5px;
}

.margin-l-6 {
  margin-left: 6px;
}

.margin-l-7 {
  margin-left: 7px;
}

.margin-l-8 {
  margin-left: 8px;
}

.margin-l-9 {
  margin-left: 9px;
}

.margin-l-10 {
  margin-left: 10px;
}

.margin-l-11 {
  margin-left: 11px;
}

.margin-l-12 {
  margin-left: 12px;
}

.margin-l-13 {
  margin-left: 13px;
}

.margin-l-14 {
  margin-left: 14px;
}

.margin-l-15 {
  margin-left: 15px;
}

.margin-l-16 {
  margin-left: 16px;
}

.margin-l-17 {
  margin-left: 17px;
}

.margin-l-18 {
  margin-left: 18px;
}

.margin-l-19 {
  margin-left: 19px;
}

.margin-l-20 {
  margin-left: 20px;
}

.margin-l-21 {
  margin-left: 21px;
}

.margin-l-22 {
  margin-left: 22px;
}

.margin-l-23 {
  margin-left: 23px;
}

.margin-l-24 {
  margin-left: 24px;
}

.margin-l-25 {
  margin-left: 25px;
}

.margin-l-26 {
  margin-left: 26px;
}

.margin-l-27 {
  margin-left: 27px;
}

.margin-l-28 {
  margin-left: 28px;
}

.margin-l-29 {
  margin-left: 29px;
}

.margin-l-30 {
  margin-left: 30px;
}

.margin-l-31 {
  margin-left: 31px;
}

.margin-l-32 {
  margin-left: 32px;
}

.margin-l-33 {
  margin-left: 33px;
}

.margin-l-34 {
  margin-left: 34px;
}

.margin-l-35 {
  margin-left: 35px;
}

.margin-l-36 {
  margin-left: 36px;
}

.margin-l-37 {
  margin-left: 37px;
}

.margin-l-38 {
  margin-left: 38px;
}

.margin-l-39 {
  margin-left: 39px;
}

.margin-l-40 {
  margin-left: 40px;
}

.margin-l-41 {
  margin-left: 41px;
}

.margin-l-42 {
  margin-left: 42px;
}

.margin-l-43 {
  margin-left: 43px;
}

.margin-l-44 {
  margin-left: 44px;
}

.margin-l-45 {
  margin-left: 45px;
}

.margin-l-46 {
  margin-left: 46px;
}

.margin-l-47 {
  margin-left: 47px;
}

.margin-l-48 {
  margin-left: 48px;
}

.margin-l-49 {
  margin-left: 49px;
}

.margin-l-50 {
  margin-left: 50px;
}

.margin-l-51 {
  margin-left: 51px;
}

.margin-l-52 {
  margin-left: 52px;
}

.margin-l-53 {
  margin-left: 53px;
}

.margin-l-54 {
  margin-left: 54px;
}

.margin-l-55 {
  margin-left: 55px;
}

.margin-l-56 {
  margin-left: 56px;
}

.margin-l-57 {
  margin-left: 57px;
}

.margin-l-58 {
  margin-left: 58px;
}

.margin-l-59 {
  margin-left: 59px;
}

.margin-l-60 {
  margin-left: 60px;
}

.margin-l-61 {
  margin-left: 61px;
}

.margin-l-62 {
  margin-left: 62px;
}

.margin-l-63 {
  margin-left: 63px;
}

.margin-l-64 {
  margin-left: 64px;
}

.margin-l-65 {
  margin-left: 65px;
}

.margin-l-66 {
  margin-left: 66px;
}

.margin-l-67 {
  margin-left: 67px;
}

.margin-l-68 {
  margin-left: 68px;
}

.margin-l-69 {
  margin-left: 69px;
}

.margin-l-70 {
  margin-left: 70px;
}

.margin-l-71 {
  margin-left: 71px;
}

.margin-l-72 {
  margin-left: 72px;
}

.margin-l-73 {
  margin-left: 73px;
}

.margin-l-74 {
  margin-left: 74px;
}

.margin-l-75 {
  margin-left: 75px;
}

.margin-l-76 {
  margin-left: 76px;
}

.margin-l-77 {
  margin-left: 77px;
}

.margin-l-78 {
  margin-left: 78px;
}

.margin-l-79 {
  margin-left: 79px;
}

.margin-l-80 {
  margin-left: 80px;
}

.margin-l-81 {
  margin-left: 81px;
}

.margin-l-82 {
  margin-left: 82px;
}

.margin-l-83 {
  margin-left: 83px;
}

.margin-l-84 {
  margin-left: 84px;
}

.margin-l-85 {
  margin-left: 85px;
}

.margin-l-86 {
  margin-left: 86px;
}

.margin-l-87 {
  margin-left: 87px;
}

.margin-l-88 {
  margin-left: 88px;
}

.margin-l-89 {
  margin-left: 89px;
}

.margin-l-90 {
  margin-left: 90px;
}

.margin-l-91 {
  margin-left: 91px;
}

.margin-l-92 {
  margin-left: 92px;
}

.margin-l-93 {
  margin-left: 93px;
}

.margin-l-94 {
  margin-left: 94px;
}

.margin-l-95 {
  margin-left: 95px;
}

.margin-l-96 {
  margin-left: 96px;
}

.margin-l-97 {
  margin-left: 97px;
}

.margin-l-98 {
  margin-left: 98px;
}

.margin-l-99 {
  margin-left: 99px;
}

.margin-l-100 {
  margin-left: 100px;
}

.margin-r-0 {
  margin-right: 0px;
}

.margin-r-1 {
  margin-right: 1px;
}

.margin-r-2 {
  margin-right: 2px;
}

.margin-r-3 {
  margin-right: 3px;
}

.margin-r-4 {
  margin-right: 4px;
}

.margin-r-5 {
  margin-right: 5px;
}

.margin-r-6 {
  margin-right: 6px;
}

.margin-r-7 {
  margin-right: 7px;
}

.margin-r-8 {
  margin-right: 8px;
}

.margin-r-9 {
  margin-right: 9px;
}

.margin-r-10 {
  margin-right: 10px;
}

.margin-r-11 {
  margin-right: 11px;
}

.margin-r-12 {
  margin-right: 12px;
}

.margin-r-13 {
  margin-right: 13px;
}

.margin-r-14 {
  margin-right: 14px;
}

.margin-r-15 {
  margin-right: 15px;
}

.margin-r-16 {
  margin-right: 16px;
}

.margin-r-17 {
  margin-right: 17px;
}

.margin-r-18 {
  margin-right: 18px;
}

.margin-r-19 {
  margin-right: 19px;
}

.margin-r-20 {
  margin-right: 20px;
}

.margin-r-21 {
  margin-right: 21px;
}

.margin-r-22 {
  margin-right: 22px;
}

.margin-r-23 {
  margin-right: 23px;
}

.margin-r-24 {
  margin-right: 24px;
}

.margin-r-25 {
  margin-right: 25px;
}

.margin-r-26 {
  margin-right: 26px;
}

.margin-r-27 {
  margin-right: 27px;
}

.margin-r-28 {
  margin-right: 28px;
}

.margin-r-29 {
  margin-right: 29px;
}

.margin-r-30 {
  margin-right: 30px;
}

.margin-r-31 {
  margin-right: 31px;
}

.margin-r-32 {
  margin-right: 32px;
}

.margin-r-33 {
  margin-right: 33px;
}

.margin-r-34 {
  margin-right: 34px;
}

.margin-r-35 {
  margin-right: 35px;
}

.margin-r-36 {
  margin-right: 36px;
}

.margin-r-37 {
  margin-right: 37px;
}

.margin-r-38 {
  margin-right: 38px;
}

.margin-r-39 {
  margin-right: 39px;
}

.margin-r-40 {
  margin-right: 40px;
}

.margin-r-41 {
  margin-right: 41px;
}

.margin-r-42 {
  margin-right: 42px;
}

.margin-r-43 {
  margin-right: 43px;
}

.margin-r-44 {
  margin-right: 44px;
}

.margin-r-45 {
  margin-right: 45px;
}

.margin-r-46 {
  margin-right: 46px;
}

.margin-r-47 {
  margin-right: 47px;
}

.margin-r-48 {
  margin-right: 48px;
}

.margin-r-49 {
  margin-right: 49px;
}

.margin-r-50 {
  margin-right: 50px;
}

.margin-r-51 {
  margin-right: 51px;
}

.margin-r-52 {
  margin-right: 52px;
}

.margin-r-53 {
  margin-right: 53px;
}

.margin-r-54 {
  margin-right: 54px;
}

.margin-r-55 {
  margin-right: 55px;
}

.margin-r-56 {
  margin-right: 56px;
}

.margin-r-57 {
  margin-right: 57px;
}

.margin-r-58 {
  margin-right: 58px;
}

.margin-r-59 {
  margin-right: 59px;
}

.margin-r-60 {
  margin-right: 60px;
}

.margin-r-61 {
  margin-right: 61px;
}

.margin-r-62 {
  margin-right: 62px;
}

.margin-r-63 {
  margin-right: 63px;
}

.margin-r-64 {
  margin-right: 64px;
}

.margin-r-65 {
  margin-right: 65px;
}

.margin-r-66 {
  margin-right: 66px;
}

.margin-r-67 {
  margin-right: 67px;
}

.margin-r-68 {
  margin-right: 68px;
}

.margin-r-69 {
  margin-right: 69px;
}

.margin-r-70 {
  margin-right: 70px;
}

.margin-r-71 {
  margin-right: 71px;
}

.margin-r-72 {
  margin-right: 72px;
}

.margin-r-73 {
  margin-right: 73px;
}

.margin-r-74 {
  margin-right: 74px;
}

.margin-r-75 {
  margin-right: 75px;
}

.margin-r-76 {
  margin-right: 76px;
}

.margin-r-77 {
  margin-right: 77px;
}

.margin-r-78 {
  margin-right: 78px;
}

.margin-r-79 {
  margin-right: 79px;
}

.margin-r-80 {
  margin-right: 80px;
}

.margin-r-81 {
  margin-right: 81px;
}

.margin-r-82 {
  margin-right: 82px;
}

.margin-r-83 {
  margin-right: 83px;
}

.margin-r-84 {
  margin-right: 84px;
}

.margin-r-85 {
  margin-right: 85px;
}

.margin-r-86 {
  margin-right: 86px;
}

.margin-r-87 {
  margin-right: 87px;
}

.margin-r-88 {
  margin-right: 88px;
}

.margin-r-89 {
  margin-right: 89px;
}

.margin-r-90 {
  margin-right: 90px;
}

.margin-r-91 {
  margin-right: 91px;
}

.margin-r-92 {
  margin-right: 92px;
}

.margin-r-93 {
  margin-right: 93px;
}

.margin-r-94 {
  margin-right: 94px;
}

.margin-r-95 {
  margin-right: 95px;
}

.margin-r-96 {
  margin-right: 96px;
}

.margin-r-97 {
  margin-right: 97px;
}

.margin-r-98 {
  margin-right: 98px;
}

.margin-r-99 {
  margin-right: 99px;
}

.margin-r-100 {
  margin-right: 100px;
}

.margin-b-0 {
  margin-bottom: 0px;
}

.margin-b-1 {
  margin-bottom: 1px;
}

.margin-b-2 {
  margin-bottom: 2px;
}

.margin-b-3 {
  margin-bottom: 3px;
}

.margin-b-4 {
  margin-bottom: 4px;
}

.margin-b-5 {
  margin-bottom: 5px;
}

.margin-b-6 {
  margin-bottom: 6px;
}

.margin-b-7 {
  margin-bottom: 7px;
}

.margin-b-8 {
  margin-bottom: 8px;
}

.margin-b-9 {
  margin-bottom: 9px;
}

.margin-b-10 {
  margin-bottom: 10px;
}

.margin-b-11 {
  margin-bottom: 11px;
}

.margin-b-12 {
  margin-bottom: 12px;
}

.margin-b-13 {
  margin-bottom: 13px;
}

.margin-b-14 {
  margin-bottom: 14px;
}

.margin-b-15 {
  margin-bottom: 15px;
}

.margin-b-16 {
  margin-bottom: 16px;
}

.margin-b-17 {
  margin-bottom: 17px;
}

.margin-b-18 {
  margin-bottom: 18px;
}

.margin-b-19 {
  margin-bottom: 19px;
}

.margin-b-20 {
  margin-bottom: 20px;
}

.margin-b-21 {
  margin-bottom: 21px;
}

.margin-b-22 {
  margin-bottom: 22px;
}

.margin-b-23 {
  margin-bottom: 23px;
}

.margin-b-24 {
  margin-bottom: 24px;
}

.margin-b-25 {
  margin-bottom: 25px;
}

.margin-b-26 {
  margin-bottom: 26px;
}

.margin-b-27 {
  margin-bottom: 27px;
}

.margin-b-28 {
  margin-bottom: 28px;
}

.margin-b-29 {
  margin-bottom: 29px;
}

.margin-b-30 {
  margin-bottom: 30px;
}

.margin-b-31 {
  margin-bottom: 31px;
}

.margin-b-32 {
  margin-bottom: 32px;
}

.margin-b-33 {
  margin-bottom: 33px;
}

.margin-b-34 {
  margin-bottom: 34px;
}

.margin-b-35 {
  margin-bottom: 35px;
}

.margin-b-36 {
  margin-bottom: 36px;
}

.margin-b-37 {
  margin-bottom: 37px;
}

.margin-b-38 {
  margin-bottom: 38px;
}

.margin-b-39 {
  margin-bottom: 39px;
}

.margin-b-40 {
  margin-bottom: 40px;
}

.margin-b-41 {
  margin-bottom: 41px;
}

.margin-b-42 {
  margin-bottom: 42px;
}

.margin-b-43 {
  margin-bottom: 43px;
}

.margin-b-44 {
  margin-bottom: 44px;
}

.margin-b-45 {
  margin-bottom: 45px;
}

.margin-b-46 {
  margin-bottom: 46px;
}

.margin-b-47 {
  margin-bottom: 47px;
}

.margin-b-48 {
  margin-bottom: 48px;
}

.margin-b-49 {
  margin-bottom: 49px;
}

.margin-b-50 {
  margin-bottom: 50px;
}

.margin-b-51 {
  margin-bottom: 51px;
}

.margin-b-52 {
  margin-bottom: 52px;
}

.margin-b-53 {
  margin-bottom: 53px;
}

.margin-b-54 {
  margin-bottom: 54px;
}

.margin-b-55 {
  margin-bottom: 55px;
}

.margin-b-56 {
  margin-bottom: 56px;
}

.margin-b-57 {
  margin-bottom: 57px;
}

.margin-b-58 {
  margin-bottom: 58px;
}

.margin-b-59 {
  margin-bottom: 59px;
}

.margin-b-60 {
  margin-bottom: 60px;
}

.margin-b-61 {
  margin-bottom: 61px;
}

.margin-b-62 {
  margin-bottom: 62px;
}

.margin-b-63 {
  margin-bottom: 63px;
}

.margin-b-64 {
  margin-bottom: 64px;
}

.margin-b-65 {
  margin-bottom: 65px;
}

.margin-b-66 {
  margin-bottom: 66px;
}

.margin-b-67 {
  margin-bottom: 67px;
}

.margin-b-68 {
  margin-bottom: 68px;
}

.margin-b-69 {
  margin-bottom: 69px;
}

.margin-b-70 {
  margin-bottom: 70px;
}

.margin-b-71 {
  margin-bottom: 71px;
}

.margin-b-72 {
  margin-bottom: 72px;
}

.margin-b-73 {
  margin-bottom: 73px;
}

.margin-b-74 {
  margin-bottom: 74px;
}

.margin-b-75 {
  margin-bottom: 75px;
}

.margin-b-76 {
  margin-bottom: 76px;
}

.margin-b-77 {
  margin-bottom: 77px;
}

.margin-b-78 {
  margin-bottom: 78px;
}

.margin-b-79 {
  margin-bottom: 79px;
}

.margin-b-80 {
  margin-bottom: 80px;
}

.margin-b-81 {
  margin-bottom: 81px;
}

.margin-b-82 {
  margin-bottom: 82px;
}

.margin-b-83 {
  margin-bottom: 83px;
}

.margin-b-84 {
  margin-bottom: 84px;
}

.margin-b-85 {
  margin-bottom: 85px;
}

.margin-b-86 {
  margin-bottom: 86px;
}

.margin-b-87 {
  margin-bottom: 87px;
}

.margin-b-88 {
  margin-bottom: 88px;
}

.margin-b-89 {
  margin-bottom: 89px;
}

.margin-b-90 {
  margin-bottom: 90px;
}

.margin-b-91 {
  margin-bottom: 91px;
}

.margin-b-92 {
  margin-bottom: 92px;
}

.margin-b-93 {
  margin-bottom: 93px;
}

.margin-b-94 {
  margin-bottom: 94px;
}

.margin-b-95 {
  margin-bottom: 95px;
}

.margin-b-96 {
  margin-bottom: 96px;
}

.margin-b-97 {
  margin-bottom: 97px;
}

.margin-b-98 {
  margin-bottom: 98px;
}

.margin-b-99 {
  margin-bottom: 99px;
}

.margin-b-100 {
  margin-bottom: 100px;
}

.margin-t-0 {
  margin-top: 0px;
}

.margin-t-1 {
  margin-top: 1px;
}

.margin-t-2 {
  margin-top: 2px;
}

.margin-t-3 {
  margin-top: 3px;
}

.margin-t-4 {
  margin-top: 4px;
}

.margin-t-5 {
  margin-top: 5px;
}

.margin-t-6 {
  margin-top: 6px;
}

.margin-t-7 {
  margin-top: 7px;
}

.margin-t-8 {
  margin-top: 8px;
}

.margin-t-9 {
  margin-top: 9px;
}

.margin-t-10 {
  margin-top: 10px;
}

.margin-t-11 {
  margin-top: 11px;
}

.margin-t-12 {
  margin-top: 12px;
}

.margin-t-13 {
  margin-top: 13px;
}

.margin-t-14 {
  margin-top: 14px;
}

.margin-t-15 {
  margin-top: 15px;
}

.margin-t-16 {
  margin-top: 16px;
}

.margin-t-17 {
  margin-top: 17px;
}

.margin-t-18 {
  margin-top: 18px;
}

.margin-t-19 {
  margin-top: 19px;
}

.margin-t-20 {
  margin-top: 20px;
}

.margin-t-21 {
  margin-top: 21px;
}

.margin-t-22 {
  margin-top: 22px;
}

.margin-t-23 {
  margin-top: 23px;
}

.margin-t-24 {
  margin-top: 24px;
}

.margin-t-25 {
  margin-top: 25px;
}

.margin-t-26 {
  margin-top: 26px;
}

.margin-t-27 {
  margin-top: 27px;
}

.margin-t-28 {
  margin-top: 28px;
}

.margin-t-29 {
  margin-top: 29px;
}

.margin-t-30 {
  margin-top: 30px;
}

.margin-t-31 {
  margin-top: 31px;
}

.margin-t-32 {
  margin-top: 32px;
}

.margin-t-33 {
  margin-top: 33px;
}

.margin-t-34 {
  margin-top: 34px;
}

.margin-t-35 {
  margin-top: 35px;
}

.margin-t-36 {
  margin-top: 36px;
}

.margin-t-37 {
  margin-top: 37px;
}

.margin-t-38 {
  margin-top: 38px;
}

.margin-t-39 {
  margin-top: 39px;
}

.margin-t-40 {
  margin-top: 40px;
}

.margin-t-41 {
  margin-top: 41px;
}

.margin-t-42 {
  margin-top: 42px;
}

.margin-t-43 {
  margin-top: 43px;
}

.margin-t-44 {
  margin-top: 44px;
}

.margin-t-45 {
  margin-top: 45px;
}

.margin-t-46 {
  margin-top: 46px;
}

.margin-t-47 {
  margin-top: 47px;
}

.margin-t-48 {
  margin-top: 48px;
}

.margin-t-49 {
  margin-top: 49px;
}

.margin-t-50 {
  margin-top: 50px;
}

.margin-t-51 {
  margin-top: 51px;
}

.margin-t-52 {
  margin-top: 52px;
}

.margin-t-53 {
  margin-top: 53px;
}

.margin-t-54 {
  margin-top: 54px;
}

.margin-t-55 {
  margin-top: 55px;
}

.margin-t-56 {
  margin-top: 56px;
}

.margin-t-57 {
  margin-top: 57px;
}

.margin-t-58 {
  margin-top: 58px;
}

.margin-t-59 {
  margin-top: 59px;
}

.margin-t-60 {
  margin-top: 60px;
}

.margin-t-61 {
  margin-top: 61px;
}

.margin-t-62 {
  margin-top: 62px;
}

.margin-t-63 {
  margin-top: 63px;
}

.margin-t-64 {
  margin-top: 64px;
}

.margin-t-65 {
  margin-top: 65px;
}

.margin-t-66 {
  margin-top: 66px;
}

.margin-t-67 {
  margin-top: 67px;
}

.margin-t-68 {
  margin-top: 68px;
}

.margin-t-69 {
  margin-top: 69px;
}

.margin-t-70 {
  margin-top: 70px;
}

.margin-t-71 {
  margin-top: 71px;
}

.margin-t-72 {
  margin-top: 72px;
}

.margin-t-73 {
  margin-top: 73px;
}

.margin-t-74 {
  margin-top: 74px;
}

.margin-t-75 {
  margin-top: 75px;
}

.margin-t-76 {
  margin-top: 76px;
}

.margin-t-77 {
  margin-top: 77px;
}

.margin-t-78 {
  margin-top: 78px;
}

.margin-t-79 {
  margin-top: 79px;
}

.margin-t-80 {
  margin-top: 80px;
}

.margin-t-81 {
  margin-top: 81px;
}

.margin-t-82 {
  margin-top: 82px;
}

.margin-t-83 {
  margin-top: 83px;
}

.margin-t-84 {
  margin-top: 84px;
}

.margin-t-85 {
  margin-top: 85px;
}

.margin-t-86 {
  margin-top: 86px;
}

.margin-t-87 {
  margin-top: 87px;
}

.margin-t-88 {
  margin-top: 88px;
}

.margin-t-89 {
  margin-top: 89px;
}

.margin-t-90 {
  margin-top: 90px;
}

.margin-t-91 {
  margin-top: 91px;
}

.margin-t-92 {
  margin-top: 92px;
}

.margin-t-93 {
  margin-top: 93px;
}

.margin-t-94 {
  margin-top: 94px;
}

.margin-t-95 {
  margin-top: 95px;
}

.margin-t-96 {
  margin-top: 96px;
}

.margin-t-97 {
  margin-top: 97px;
}

.margin-t-98 {
  margin-top: 98px;
}

.margin-t-99 {
  margin-top: 99px;
}

.margin-t-100 {
  margin-top: 100px;
}
@keyframes closeScaleUpFromCenter {
  0% {
    z-index: 4001;
    opacity: 1;
    teansform: scale(1);
  }
  100% {
    transform: scale(1.3);
    opacity: 0;
    z-index: -10;
  }
}
@keyframes openScaleDownFromCenter {
  0% {
    opacity: 0.5;
    teansform: scale(1.4);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.perplexity-sidebar-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  pointer-events: none;
}
@media screen and (max-width: 768px) {
  .perplexity-sidebar-wrapper {
    display: none;
  }
}
.perplexity-sidebar-wrapper > * {
  pointer-events: auto;
}

.perplexity-sidebar {
  width: 72px;
  height: 100%;
  background: linear-gradient(180deg, #0a0b0d 0%, #000000 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  z-index: 10000;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.5);
}
.perplexity-sidebar__top {
  padding: 20px 0;
  display: flex;
  justify-content: center;
}
.perplexity-sidebar__logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.perplexity-sidebar__logo img {
  max-width: 40px;
  height: auto;
  display: block;
}
.perplexity-sidebar__nav {
  flex: 1 1;
  padding: 10px 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.perplexity-sidebar__nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 4px;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  color: rgba(255, 255, 255, 0.75);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
}
.perplexity-sidebar__nav-item:hover {
  background-color: transparent !important;
  color: white;
}
.perplexity-sidebar__nav-item:hover .perplexity-sidebar__item-icon svg {
  fill: #006cff;
}
.perplexity-sidebar__nav-item.active {
  background-color: rgba(0, 108, 255, 0.12);
  color: white;
}
.perplexity-sidebar__nav-item.active .perplexity-sidebar__item-icon svg {
  fill: #006cff;
  filter: drop-shadow(0 0 8px rgba(0, 108, 255, 0.5));
}
.perplexity-sidebar__nav-item.active::after {
  content: "";
  position: absolute;
  left: 0;
  top: 20%;
  bottom: 20%;
  width: 3px;
  background: linear-gradient(to bottom, #006cff, #4A90E2);
  border-radius: 0 4px 4px 0;
  box-shadow: 0 0 10px rgba(0, 108, 255, 0.6);
}
.perplexity-sidebar__item-icon {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
  border-radius: 8px;
  transition: all 0.3s ease;
}
.perplexity-sidebar__item-icon svg {
  width: 22px;
  height: 22px;
  fill: currentColor;
}
.perplexity-sidebar__item-icon .material-icons {
  font-size: 22px;
}
.perplexity-sidebar__item-label {
  font-size: 9px;
  font-weight: 600;
  line-height: 1.1;
  white-space: pre-line;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.perplexity-sidebar__bottom {
  padding: 16px 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}
.perplexity-sidebar__flyout {
  position: fixed;
  top: 0;
  left: 72px;
  height: 100vh;
  width: 0;
  margin: 0;
  background-color: rgba(22, 24, 28, 0.95);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
          backdrop-filter: blur(20px) saturate(180%);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
  transition: width 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
  z-index: 9999;
  box-shadow: 10px 0 40px rgba(0, 0, 0, 0.4);
}
.perplexity-sidebar__flyout.open {
  width: 280px;
}
.perplexity-sidebar__flyout-header {
  padding: 30px 24px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.perplexity-sidebar__flyout-header h3 {
  margin: 0;
  color: white;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.01em;
  background: linear-gradient(to right, #fff, rgba(255, 255, 255, 0.7));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.perplexity-sidebar__search-container {
  padding: 0 20px 16px;
  position: relative;
  display: flex;
  align-items: center;
}
.perplexity-sidebar__search-container .material-icons {
  position: absolute;
  left: 32px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: rgba(255, 255, 255, 0.3);
  pointer-events: none;
  transition: color 0.2s ease;
}
.perplexity-sidebar__search-container input {
  width: 100%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 10px 12px 10px 38px;
  color: white;
  font-size: 13px;
  font-family: inherit;
  transition: all 0.2s ease;
  outline: none;
}
.perplexity-sidebar__search-container input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.perplexity-sidebar__search-container input:focus {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(0, 108, 255, 0.4);
  box-shadow: 0 0 0 2px rgba(0, 108, 255, 0.1);
}
.perplexity-sidebar__search-container input:focus + .material-icons {
  color: #006cff;
}
.perplexity-sidebar__pin-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}
.perplexity-sidebar__pin-btn:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.05);
}
.perplexity-sidebar__pin-btn.pinned {
  color: #006cff;
  transform: rotate(-45deg);
}
.perplexity-sidebar__pin-btn .material-icons {
  font-size: 18px;
}
.perplexity-sidebar__flyout-content {
  flex: 1 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.perplexity-sidebar__link-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 10px;
  text-decoration: none !important;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 500;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  margin: 0 4px;
  border-bottom: 2px solid transparent !important;
  box-shadow: none !important;
  outline: none !important;
  overflow: hidden;
}
.perplexity-sidebar__link-item span {
  flex: 1 1;
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
}
.perplexity-sidebar__link-item .material-icons {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.25);
  transition: all 0.3s ease;
}
.perplexity-sidebar__link-item:visited {
  color: rgba(255, 255, 255, 0.7) !important;
}
.perplexity-sidebar__link-item:hover {
  background-color: rgba(255, 255, 255, 0.03) !important;
  color: white !important;
  border-bottom-color: #006cff !important;
  transform: translateX(4px);
}
.perplexity-sidebar__link-item:hover .material-icons {
  color: #006cff;
  transform: scale(1.1);
}
.perplexity-sidebar__link-item:hover::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 10px;
  background: linear-gradient(90deg, rgba(0, 108, 255, 0.05) 0%, transparent 100%);
  pointer-events: none;
}
.perplexity-sidebar__link-item.is-loading .material-icons {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes tooltipEnter {
  from {
    opacity: 0;
    transform: translateX(10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}
.perplexity-layout {
  display: block;
  width: 100%;
  --layout-sidebar-width: 72px;
  --layout-content-padding: 16px;
  --layout-research-padding: 50px;
}
@media screen and (max-width: 768px) {
  .perplexity-layout {
    --layout-research-padding: 15px;
    --layout-sidebar-width: 0px !important;
    --layout-content-padding: 0px;
  }
}
@media screen and (max-width: 480px) {
  .perplexity-layout {
    --layout-research-padding: 10px;
  }
}
.perplexity-layout.sidebar-pinned {
  --layout-sidebar-width: 352px;
}
.perplexity-layout.no-sidebar {
  --layout-sidebar-width: 0px;
  --layout-content-padding: 0px;
}
.perplexity-layout .is-sticky {
  left: calc(var(--layout-sidebar-width) + var(--layout-content-padding) + var(--layout-research-padding)) !important;
  width: calc(100% - (var(--layout-sidebar-width) + var(--layout-content-padding) + var(--layout-research-padding) * 2)) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.perplexity-layout.no-sidebar {
  --layout-sidebar-width: 0px;
  --layout-content-padding: 0px;
}

.perplexity-content {
  margin-left: 72px;
  margin-left: var(--layout-sidebar-width, 72px);
  padding-left: 16px;
  padding-left: var(--layout-content-padding, 16px);
  width: calc(100% - 72px);
  width: calc(100% - var(--layout-sidebar-width, 72px));
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}`, "",{"version":3,"sources":["webpack://./src/scss/_variables.scss","webpack://./src/components/Navigations/PerplexitySidebar/PerplexitySidebar.scss","webpack://./src/scss/_colors.scss","webpack://./src/scss/_mixins.scss"],"names":[],"mappings":"AAwJE;EACE,cAAA;ACvJJ;;ADsJE;EACE,cAAA;ACnJJ;;ADkJE;EACE,cAAA;AC/IJ;;AD8IE;EACE,cAAA;AC3IJ;;AD0IE;EACE,cAAA;ACvIJ;;ADsIE;EACE,cAAA;ACnIJ;;ADkIE;EACE,cAAA;AC/HJ;;AD8HE;EACE,cAAA;AC3HJ;;AD0HE;EACE,cAAA;ACvHJ;;ADsHE;EACE,cAAA;ACnHJ;;ADkHE;EACE,cAAA;AC/GJ;;AD8GE;EACE,cAAA;AC3GJ;;AD0GE;EACE,cAAA;ACvGJ;;ADsGE;EACE,gCAAA;ACnGJ;;ADkGE;EACE,cAAA;AC/FJ;;AD8FE;EACE,cAAA;AC3FJ;;AD0FE;EACE,cAAA;ACvFJ;;ADsFE;EACE,cAAA;ACnFJ;;ACtEA;EACE,mBAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,iCAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,8BAAA;EAEA,iBAAA;EACA,qBAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,uCAAA;EACA,wBAAA;EACA,+CAAA;EACA,+CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,+CAAA;EACA,+CAAA;EACA,+CAAA;EACA,gEAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,qBAAA;EACA,8BAAA;EACA,mCAAA;EAEA,gBAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EAEA,iBAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,0DAAA;EACA,0DAAA;EACA,wDAAA;EAEA,4BAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,iBAAA;EACA,+BAAA;EACA,+BAAA;EACA,8BAAA;EAEA,gBAAA;EACA,0CAAA;EACA,2CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EAEA,iBAAA;EACA,6DAAA;EACA,kEAAA;EACA,8DAAA;EACA,oEAAA;EAEA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AD+DF;;AC5DA,yCAAA;AACA;EACE,6CAAA;EACA,4BAAA,EAAA,iCAAA;EACA,4BAAA,EAAA,kCAAA;EACA,4BAAA,EAAA,mCAAA;EACA,4BAAA,EAAA,qCAAA;EACA,gDAAA,EAAA,oBAAA;EACA,4BAAA,EAAA,4BAAA;EACA,4BAAA,EAAA,4BAAA;EACA,4BAAA,EAAA,+BAAA;EAEA;;4DAAA;EAGA,2CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,uCAAA;EACA,+CAAA;EACA,+CAAA;EACA,+CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,+CAAA;EACA,+CAAA;EACA,+CAAA;EACA,gEAAA;EAEA,oDAAA;EACA,yBAAA,EAAA,mBAAA;EACA,yBAAA,EAAA,qBAAA;EACA,yBAAA,EAAA,6BAAA;EAEA,8BAAA;EACA,8BAAA,EAAA,oBAAA;EACA,kDAAA;EAEA,iDAAA;EACA,iCAAA,EAAA,yBAAA;EACA,iCAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,kBAAA;EACA,iCAAA,EAAA,mBAAA;EACA,iCAAA,EAAA,gBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,yBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,iBAAA;EACA,iCAAA,EAAA,WAAA;EACA,iCAAA,EAAA,gBAAA;EACA,iCAAA,EAAA,wBAAA;EACA,iCAAA,EAAA,SAAA;EACA,iCAAA,EAAA,WAAA;EACA,iCAAA,EAAA,cAAA;EACA,iCAAA,EAAA,2BAAA;EAEA,yCAAA;EACA,kCAAA,EAAA,yBAAA;EACA,kCAAA,EAAA,mBAAA;EACA,kCAAA,EAAA,kBAAA;EACA,kCAAA,EAAA,kBAAA;EACA,qDAAA;EACA,qDAAA;EACA,mDAAA;EAEA,gDAAA;EACA,wBAAA,EAAA,iBAAA;EACA,wBAAA,EAAA,mBAAA;EACA,wBAAA,EAAA,2BAAA;EACA,0BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,kBAAA;EAEA,kDAAA;EACA,+BAAA;EACA,+BAAA;EACA,8BAAA;EAEA,yCAAA;EACA,gDAAA;EACA,iDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,iDAAA;EAEA,8BAAA;EACA,6DAAA;EACA,mEAAA;EACA,oEAAA;EACA,0EAAA;EACA,mBAAA;EACA,mBAAA;ADsDF;;AC6BA;EACE,cA/EkB;ADqDpB;;AC6BA;EACE,cA/EkB;ADqDpB;;AElJI;EACE,iBAAA;AFqJN;;AEtJI;EACE,iBAAA;AFyJN;;AE1JI;EACE,iBAAA;AF6JN;;AE9JI;EACE,iBAAA;AFiKN;;AElKI;EACE,iBAAA;AFqKN;;AEtKI;EACE,iBAAA;AFyKN;;AE1KI;EACE,iBAAA;AF6KN;;AE9KI;EACE,iBAAA;AFiLN;;AElLI;EACE,iBAAA;AFqLN;;AEtLI;EACE,iBAAA;AFyLN;;AE1LI;EACE,kBAAA;AF6LN;;AE9LI;EACE,kBAAA;AFiMN;;AElMI;EACE,kBAAA;AFqMN;;AEtMI;EACE,kBAAA;AFyMN;;AE1MI;EACE,kBAAA;AF6MN;;AE9MI;EACE,kBAAA;AFiNN;;AElNI;EACE,kBAAA;AFqNN;;AEtNI;EACE,kBAAA;AFyNN;;AE1NI;EACE,kBAAA;AF6NN;;AE9NI;EACE,kBAAA;AFiON;;AElOI;EACE,kBAAA;AFqON;;AEtOI;EACE,kBAAA;AFyON;;AE1OI;EACE,kBAAA;AF6ON;;AE9OI;EACE,kBAAA;AFiPN;;AElPI;EACE,kBAAA;AFqPN;;AEtPI;EACE,kBAAA;AFyPN;;AE1PI;EACE,kBAAA;AF6PN;;AE9PI;EACE,kBAAA;AFiQN;;AElQI;EACE,kBAAA;AFqQN;;AEtQI;EACE,kBAAA;AFyQN;;AE1QI;EACE,kBAAA;AF6QN;;AE9QI;EACE,kBAAA;AFiRN;;AElRI;EACE,kBAAA;AFqRN;;AEtRI;EACE,kBAAA;AFyRN;;AE1RI;EACE,kBAAA;AF6RN;;AE9RI;EACE,kBAAA;AFiSN;;AElSI;EACE,kBAAA;AFqSN;;AEtSI;EACE,kBAAA;AFySN;;AE1SI;EACE,kBAAA;AF6SN;;AE9SI;EACE,kBAAA;AFiTN;;AElTI;EACE,kBAAA;AFqTN;;AEtTI;EACE,kBAAA;AFyTN;;AE1TI;EACE,kBAAA;AF6TN;;AE9TI;EACE,kBAAA;AFiUN;;AElUI;EACE,kBAAA;AFqUN;;AEtUI;EACE,kBAAA;AFyUN;;AE1UI;EACE,kBAAA;AF6UN;;AE9UI;EACE,kBAAA;AFiVN;;AElVI;EACE,kBAAA;AFqVN;;AEtVI;EACE,kBAAA;AFyVN;;AE1VI;EACE,kBAAA;AF6VN;;AE9VI;EACE,kBAAA;AFiWN;;AElWI;EACE,kBAAA;AFqWN;;AEtWI;EACE,kBAAA;AFyWN;;AE1WI;EACE,kBAAA;AF6WN;;AE9WI;EACE,kBAAA;AFiXN;;AElXI;EACE,kBAAA;AFqXN;;AEtXI;EACE,kBAAA;AFyXN;;AE1XI;EACE,kBAAA;AF6XN;;AE9XI;EACE,kBAAA;AFiYN;;AElYI;EACE,kBAAA;AFqYN;;AEtYI;EACE,kBAAA;AFyYN;;AE1YI;EACE,kBAAA;AF6YN;;AE9YI;EACE,kBAAA;AFiZN;;AElZI;EACE,kBAAA;AFqZN;;AEtZI;EACE,kBAAA;AFyZN;;AE1ZI;EACE,kBAAA;AF6ZN;;AE9ZI;EACE,kBAAA;AFiaN;;AElaI;EACE,kBAAA;AFqaN;;AEtaI;EACE,kBAAA;AFyaN;;AE1aI;EACE,kBAAA;AF6aN;;AE9aI;EACE,kBAAA;AFibN;;AElbI;EACE,kBAAA;AFqbN;;AEtbI;EACE,kBAAA;AFybN;;AE1bI;EACE,kBAAA;AF6bN;;AE9bI;EACE,kBAAA;AFicN;;AElcI;EACE,kBAAA;AFqcN;;AEtcI;EACE,kBAAA;AFycN;;AE1cI;EACE,kBAAA;AF6cN;;AE9cI;EACE,kBAAA;AFidN;;AEldI;EACE,kBAAA;AFqdN;;AEtdI;EACE,kBAAA;AFydN;;AE1dI;EACE,kBAAA;AF6dN;;AE9dI;EACE,kBAAA;AFieN;;AEleI;EACE,kBAAA;AFqeN;;AEteI;EACE,kBAAA;AFyeN;;AE1eI;EACE,kBAAA;AF6eN;;AE9eI;EACE,kBAAA;AFifN;;AElfI;EACE,kBAAA;AFqfN;;AEtfI;EACE,kBAAA;AFyfN;;AE1fI;EACE,kBAAA;AF6fN;;AE9fI;EACE,kBAAA;AFigBN;;AElgBI;EACE,kBAAA;AFqgBN;;AEtgBI;EACE,kBAAA;AFygBN;;AE1gBI;EACE,kBAAA;AF6gBN;;AE9gBI;EACE,kBAAA;AFihBN;;AElhBI;EACE,kBAAA;AFqhBN;;AEthBI;EACE,kBAAA;AFyhBN;;AE1hBI;EACE,kBAAA;AF6hBN;;AE9hBI;EACE,kBAAA;AFiiBN;;AEliBI;EACE,mBAAA;AFqiBN;;AEtiBI;EACE,kBAAA;AFyiBN;;AE1iBI;EACE,kBAAA;AF6iBN;;AE9iBI;EACE,kBAAA;AFijBN;;AEljBI;EACE,kBAAA;AFqjBN;;AEtjBI;EACE,kBAAA;AFyjBN;;AE1jBI;EACE,kBAAA;AF6jBN;;AE9jBI;EACE,kBAAA;AFikBN;;AElkBI;EACE,kBAAA;AFqkBN;;AEtkBI;EACE,kBAAA;AFykBN;;AE1kBI;EACE,kBAAA;AF6kBN;;AE9kBI;EACE,mBAAA;AFilBN;;AEllBI;EACE,mBAAA;AFqlBN;;AEtlBI;EACE,mBAAA;AFylBN;;AE1lBI;EACE,mBAAA;AF6lBN;;AE9lBI;EACE,mBAAA;AFimBN;;AElmBI;EACE,mBAAA;AFqmBN;;AEtmBI;EACE,mBAAA;AFymBN;;AE1mBI;EACE,mBAAA;AF6mBN;;AE9mBI;EACE,mBAAA;AFinBN;;AElnBI;EACE,mBAAA;AFqnBN;;AEtnBI;EACE,mBAAA;AFynBN;;AE1nBI;EACE,mBAAA;AF6nBN;;AE9nBI;EACE,mBAAA;AFioBN;;AEloBI;EACE,mBAAA;AFqoBN;;AEtoBI;EACE,mBAAA;AFyoBN;;AE1oBI;EACE,mBAAA;AF6oBN;;AE9oBI;EACE,mBAAA;AFipBN;;AElpBI;EACE,mBAAA;AFqpBN;;AEtpBI;EACE,mBAAA;AFypBN;;AE1pBI;EACE,mBAAA;AF6pBN;;AE9pBI;EACE,mBAAA;AFiqBN;;AElqBI;EACE,mBAAA;AFqqBN;;AEtqBI;EACE,mBAAA;AFyqBN;;AE1qBI;EACE,mBAAA;AF6qBN;;AE9qBI;EACE,mBAAA;AFirBN;;AElrBI;EACE,mBAAA;AFqrBN;;AEtrBI;EACE,mBAAA;AFyrBN;;AE1rBI;EACE,mBAAA;AF6rBN;;AE9rBI;EACE,mBAAA;AFisBN;;AElsBI;EACE,mBAAA;AFqsBN;;AEtsBI;EACE,mBAAA;AFysBN;;AE1sBI;EACE,mBAAA;AF6sBN;;AE9sBI;EACE,mBAAA;AFitBN;;AEltBI;EACE,mBAAA;AFqtBN;;AEttBI;EACE,mBAAA;AFytBN;;AE1tBI;EACE,mBAAA;AF6tBN;;AE9tBI;EACE,mBAAA;AFiuBN;;AEluBI;EACE,mBAAA;AFquBN;;AEtuBI;EACE,mBAAA;AFyuBN;;AE1uBI;EACE,mBAAA;AF6uBN;;AE9uBI;EACE,mBAAA;AFivBN;;AElvBI;EACE,mBAAA;AFqvBN;;AEtvBI;EACE,mBAAA;AFyvBN;;AE1vBI;EACE,mBAAA;AF6vBN;;AE9vBI;EACE,mBAAA;AFiwBN;;AElwBI;EACE,mBAAA;AFqwBN;;AEtwBI;EACE,mBAAA;AFywBN;;AE1wBI;EACE,mBAAA;AF6wBN;;AE9wBI;EACE,mBAAA;AFixBN;;AElxBI;EACE,mBAAA;AFqxBN;;AEtxBI;EACE,mBAAA;AFyxBN;;AE1xBI;EACE,mBAAA;AF6xBN;;AE9xBI;EACE,mBAAA;AFiyBN;;AElyBI;EACE,mBAAA;AFqyBN;;AEtyBI;EACE,mBAAA;AFyyBN;;AE1yBI;EACE,mBAAA;AF6yBN;;AE9yBI;EACE,mBAAA;AFizBN;;AElzBI;EACE,mBAAA;AFqzBN;;AEtzBI;EACE,mBAAA;AFyzBN;;AE1zBI;EACE,mBAAA;AF6zBN;;AE9zBI;EACE,mBAAA;AFi0BN;;AEl0BI;EACE,mBAAA;AFq0BN;;AEt0BI;EACE,mBAAA;AFy0BN;;AE10BI;EACE,mBAAA;AF60BN;;AE90BI;EACE,mBAAA;AFi1BN;;AEl1BI;EACE,mBAAA;AFq1BN;;AEt1BI;EACE,mBAAA;AFy1BN;;AE11BI;EACE,mBAAA;AF61BN;;AE91BI;EACE,mBAAA;AFi2BN;;AEl2BI;EACE,mBAAA;AFq2BN;;AEt2BI;EACE,mBAAA;AFy2BN;;AE12BI;EACE,mBAAA;AF62BN;;AE92BI;EACE,mBAAA;AFi3BN;;AEl3BI;EACE,mBAAA;AFq3BN;;AEt3BI;EACE,mBAAA;AFy3BN;;AE13BI;EACE,mBAAA;AF63BN;;AE93BI;EACE,mBAAA;AFi4BN;;AEl4BI;EACE,mBAAA;AFq4BN;;AEt4BI;EACE,mBAAA;AFy4BN;;AE14BI;EACE,mBAAA;AF64BN;;AE94BI;EACE,mBAAA;AFi5BN;;AEl5BI;EACE,mBAAA;AFq5BN;;AEt5BI;EACE,mBAAA;AFy5BN;;AE15BI;EACE,mBAAA;AF65BN;;AE95BI;EACE,mBAAA;AFi6BN;;AEl6BI;EACE,mBAAA;AFq6BN;;AEt6BI;EACE,mBAAA;AFy6BN;;AE16BI;EACE,mBAAA;AF66BN;;AE96BI;EACE,mBAAA;AFi7BN;;AEl7BI;EACE,mBAAA;AFq7BN;;AEt7BI;EACE,oBAAA;AFy7BN;;AE17BI;EACE,mBAAA;AF67BN;;AE97BI;EACE,mBAAA;AFi8BN;;AEl8BI;EACE,mBAAA;AFq8BN;;AEt8BI;EACE,mBAAA;AFy8BN;;AE18BI;EACE,mBAAA;AF68BN;;AE98BI;EACE,mBAAA;AFi9BN;;AEl9BI;EACE,mBAAA;AFq9BN;;AEt9BI;EACE,mBAAA;AFy9BN;;AE19BI;EACE,mBAAA;AF69BN;;AE99BI;EACE,mBAAA;AFi+BN;;AEl+BI;EACE,oBAAA;AFq+BN;;AEt+BI;EACE,oBAAA;AFy+BN;;AE1+BI;EACE,oBAAA;AF6+BN;;AE9+BI;EACE,oBAAA;AFi/BN;;AEl/BI;EACE,oBAAA;AFq/BN;;AEt/BI;EACE,oBAAA;AFy/BN;;AE1/BI;EACE,oBAAA;AF6/BN;;AE9/BI;EACE,oBAAA;AFigCN;;AElgCI;EACE,oBAAA;AFqgCN;;AEtgCI;EACE,oBAAA;AFygCN;;AE1gCI;EACE,oBAAA;AF6gCN;;AE9gCI;EACE,oBAAA;AFihCN;;AElhCI;EACE,oBAAA;AFqhCN;;AEthCI;EACE,oBAAA;AFyhCN;;AE1hCI;EACE,oBAAA;AF6hCN;;AE9hCI;EACE,oBAAA;AFiiCN;;AEliCI;EACE,oBAAA;AFqiCN;;AEtiCI;EACE,oBAAA;AFyiCN;;AE1iCI;EACE,oBAAA;AF6iCN;;AE9iCI;EACE,oBAAA;AFijCN;;AEljCI;EACE,oBAAA;AFqjCN;;AEtjCI;EACE,oBAAA;AFyjCN;;AE1jCI;EACE,oBAAA;AF6jCN;;AE9jCI;EACE,oBAAA;AFikCN;;AElkCI;EACE,oBAAA;AFqkCN;;AEtkCI;EACE,oBAAA;AFykCN;;AE1kCI;EACE,oBAAA;AF6kCN;;AE9kCI;EACE,oBAAA;AFilCN;;AEllCI;EACE,oBAAA;AFqlCN;;AEtlCI;EACE,oBAAA;AFylCN;;AE1lCI;EACE,oBAAA;AF6lCN;;AE9lCI;EACE,oBAAA;AFimCN;;AElmCI;EACE,oBAAA;AFqmCN;;AEtmCI;EACE,oBAAA;AFymCN;;AE1mCI;EACE,oBAAA;AF6mCN;;AE9mCI;EACE,oBAAA;AFinCN;;AElnCI;EACE,oBAAA;AFqnCN;;AEtnCI;EACE,oBAAA;AFynCN;;AE1nCI;EACE,oBAAA;AF6nCN;;AE9nCI;EACE,oBAAA;AFioCN;;AEloCI;EACE,oBAAA;AFqoCN;;AEtoCI;EACE,oBAAA;AFyoCN;;AE1oCI;EACE,oBAAA;AF6oCN;;AE9oCI;EACE,oBAAA;AFipCN;;AElpCI;EACE,oBAAA;AFqpCN;;AEtpCI;EACE,oBAAA;AFypCN;;AE1pCI;EACE,oBAAA;AF6pCN;;AE9pCI;EACE,oBAAA;AFiqCN;;AElqCI;EACE,oBAAA;AFqqCN;;AEtqCI;EACE,oBAAA;AFyqCN;;AE1qCI;EACE,oBAAA;AF6qCN;;AE9qCI;EACE,oBAAA;AFirCN;;AElrCI;EACE,oBAAA;AFqrCN;;AEtrCI;EACE,oBAAA;AFyrCN;;AE1rCI;EACE,oBAAA;AF6rCN;;AE9rCI;EACE,oBAAA;AFisCN;;AElsCI;EACE,oBAAA;AFqsCN;;AEtsCI;EACE,oBAAA;AFysCN;;AE1sCI;EACE,oBAAA;AF6sCN;;AE9sCI;EACE,oBAAA;AFitCN;;AEltCI;EACE,oBAAA;AFqtCN;;AEttCI;EACE,oBAAA;AFytCN;;AE1tCI;EACE,oBAAA;AF6tCN;;AE9tCI;EACE,oBAAA;AFiuCN;;AEluCI;EACE,oBAAA;AFquCN;;AEtuCI;EACE,oBAAA;AFyuCN;;AE1uCI;EACE,oBAAA;AF6uCN;;AE9uCI;EACE,oBAAA;AFivCN;;AElvCI;EACE,oBAAA;AFqvCN;;AEtvCI;EACE,oBAAA;AFyvCN;;AE1vCI;EACE,oBAAA;AF6vCN;;AE9vCI;EACE,oBAAA;AFiwCN;;AElwCI;EACE,oBAAA;AFqwCN;;AEtwCI;EACE,oBAAA;AFywCN;;AE1wCI;EACE,oBAAA;AF6wCN;;AE9wCI;EACE,oBAAA;AFixCN;;AElxCI;EACE,oBAAA;AFqxCN;;AEtxCI;EACE,oBAAA;AFyxCN;;AE1xCI;EACE,oBAAA;AF6xCN;;AE9xCI;EACE,oBAAA;AFiyCN;;AElyCI;EACE,oBAAA;AFqyCN;;AEtyCI;EACE,oBAAA;AFyyCN;;AE1yCI;EACE,oBAAA;AF6yCN;;AE9yCI;EACE,oBAAA;AFizCN;;AElzCI;EACE,oBAAA;AFqzCN;;AEtzCI;EACE,oBAAA;AFyzCN;;AE1zCI;EACE,oBAAA;AF6zCN;;AE9zCI;EACE,oBAAA;AFi0CN;;AEl0CI;EACE,oBAAA;AFq0CN;;AEt0CI;EACE,oBAAA;AFy0CN;;AE10CI;EACE,qBAAA;AF60CN;;AE90CI;EACE,gBAAA;AFi1CN;;AEl1CI;EACE,gBAAA;AFq1CN;;AEt1CI;EACE,gBAAA;AFy1CN;;AE11CI;EACE,gBAAA;AF61CN;;AE91CI;EACE,gBAAA;AFi2CN;;AEl2CI;EACE,gBAAA;AFq2CN;;AEt2CI;EACE,gBAAA;AFy2CN;;AE12CI;EACE,gBAAA;AF62CN;;AE92CI;EACE,gBAAA;AFi3CN;;AEl3CI;EACE,gBAAA;AFq3CN;;AEt3CI;EACE,iBAAA;AFy3CN;;AE13CI;EACE,iBAAA;AF63CN;;AE93CI;EACE,iBAAA;AFi4CN;;AEl4CI;EACE,iBAAA;AFq4CN;;AEt4CI;EACE,iBAAA;AFy4CN;;AE14CI;EACE,iBAAA;AF64CN;;AE94CI;EACE,iBAAA;AFi5CN;;AEl5CI;EACE,iBAAA;AFq5CN;;AEt5CI;EACE,iBAAA;AFy5CN;;AE15CI;EACE,iBAAA;AF65CN;;AE95CI;EACE,iBAAA;AFi6CN;;AEl6CI;EACE,iBAAA;AFq6CN;;AEt6CI;EACE,iBAAA;AFy6CN;;AE16CI;EACE,iBAAA;AF66CN;;AE96CI;EACE,iBAAA;AFi7CN;;AEl7CI;EACE,iBAAA;AFq7CN;;AEt7CI;EACE,iBAAA;AFy7CN;;AE17CI;EACE,iBAAA;AF67CN;;AE97CI;EACE,iBAAA;AFi8CN;;AEl8CI;EACE,iBAAA;AFq8CN;;AEt8CI;EACE,iBAAA;AFy8CN;;AE18CI;EACE,iBAAA;AF68CN;;AE98CI;EACE,iBAAA;AFi9CN;;AEl9CI;EACE,iBAAA;AFq9CN;;AEt9CI;EACE,iBAAA;AFy9CN;;AE19CI;EACE,iBAAA;AF69CN;;AE99CI;EACE,iBAAA;AFi+CN;;AEl+CI;EACE,iBAAA;AFq+CN;;AEt+CI;EACE,iBAAA;AFy+CN;;AE1+CI;EACE,iBAAA;AF6+CN;;AE9+CI;EACE,iBAAA;AFi/CN;;AEl/CI;EACE,iBAAA;AFq/CN;;AEt/CI;EACE,iBAAA;AFy/CN;;AE1/CI;EACE,iBAAA;AF6/CN;;AE9/CI;EACE,iBAAA;AFigDN;;AElgDI;EACE,iBAAA;AFqgDN;;AEtgDI;EACE,iBAAA;AFygDN;;AE1gDI;EACE,iBAAA;AF6gDN;;AE9gDI;EACE,iBAAA;AFihDN;;AElhDI;EACE,iBAAA;AFqhDN;;AEthDI;EACE,iBAAA;AFyhDN;;AE1hDI;EACE,iBAAA;AF6hDN;;AE9hDI;EACE,iBAAA;AFiiDN;;AEliDI;EACE,iBAAA;AFqiDN;;AEtiDI;EACE,iBAAA;AFyiDN;;AE1iDI;EACE,iBAAA;AF6iDN;;AE9iDI;EACE,iBAAA;AFijDN;;AEljDI;EACE,iBAAA;AFqjDN;;AEtjDI;EACE,iBAAA;AFyjDN;;AE1jDI;EACE,iBAAA;AF6jDN;;AE9jDI;EACE,iBAAA;AFikDN;;AElkDI;EACE,iBAAA;AFqkDN;;AEtkDI;EACE,iBAAA;AFykDN;;AE1kDI;EACE,iBAAA;AF6kDN;;AE9kDI;EACE,iBAAA;AFilDN;;AEllDI;EACE,iBAAA;AFqlDN;;AEtlDI;EACE,iBAAA;AFylDN;;AE1lDI;EACE,iBAAA;AF6lDN;;AE9lDI;EACE,iBAAA;AFimDN;;AElmDI;EACE,iBAAA;AFqmDN;;AEtmDI;EACE,iBAAA;AFymDN;;AE1mDI;EACE,iBAAA;AF6mDN;;AE9mDI;EACE,iBAAA;AFinDN;;AElnDI;EACE,iBAAA;AFqnDN;;AEtnDI;EACE,iBAAA;AFynDN;;AE1nDI;EACE,iBAAA;AF6nDN;;AE9nDI;EACE,iBAAA;AFioDN;;AEloDI;EACE,iBAAA;AFqoDN;;AEtoDI;EACE,iBAAA;AFyoDN;;AE1oDI;EACE,iBAAA;AF6oDN;;AE9oDI;EACE,iBAAA;AFipDN;;AElpDI;EACE,iBAAA;AFqpDN;;AEtpDI;EACE,iBAAA;AFypDN;;AE1pDI;EACE,iBAAA;AF6pDN;;AE9pDI;EACE,iBAAA;AFiqDN;;AElqDI;EACE,iBAAA;AFqqDN;;AEtqDI;EACE,iBAAA;AFyqDN;;AE1qDI;EACE,iBAAA;AF6qDN;;AE9qDI;EACE,iBAAA;AFirDN;;AElrDI;EACE,iBAAA;AFqrDN;;AEtrDI;EACE,iBAAA;AFyrDN;;AE1rDI;EACE,iBAAA;AF6rDN;;AE9rDI;EACE,iBAAA;AFisDN;;AElsDI;EACE,iBAAA;AFqsDN;;AEtsDI;EACE,iBAAA;AFysDN;;AE1sDI;EACE,iBAAA;AF6sDN;;AE9sDI;EACE,iBAAA;AFitDN;;AEltDI;EACE,iBAAA;AFqtDN;;AEttDI;EACE,iBAAA;AFytDN;;AE1tDI;EACE,iBAAA;AF6tDN;;AE9tDI;EACE,kBAAA;AFiuDN;;AEluDI;EACE,gBAAA;AFquDN;;AEtuDI;EACE,gBAAA;AFyuDN;;AE1uDI;EACE,gBAAA;AF6uDN;;AE9uDI;EACE,gBAAA;AFivDN;;AElvDI;EACE,gBAAA;AFqvDN;;AEtvDI;EACE,gBAAA;AFyvDN;;AE1vDI;EACE,gBAAA;AF6vDN;;AE9vDI;EACE,gBAAA;AFiwDN;;AElwDI;EACE,gBAAA;AFqwDN;;AEtwDI;EACE,gBAAA;AFywDN;;AE1wDI;EACE,iBAAA;AF6wDN;;AE9wDI;EACE,iBAAA;AFixDN;;AElxDI;EACE,iBAAA;AFqxDN;;AEtxDI;EACE,iBAAA;AFyxDN;;AE1xDI;EACE,iBAAA;AF6xDN;;AE9xDI;EACE,iBAAA;AFiyDN;;AElyDI;EACE,iBAAA;AFqyDN;;AEtyDI;EACE,iBAAA;AFyyDN;;AE1yDI;EACE,iBAAA;AF6yDN;;AE9yDI;EACE,iBAAA;AFizDN;;AElzDI;EACE,iBAAA;AFqzDN;;AEtzDI;EACE,iBAAA;AFyzDN;;AE1zDI;EACE,iBAAA;AF6zDN;;AE9zDI;EACE,iBAAA;AFi0DN;;AEl0DI;EACE,iBAAA;AFq0DN;;AEt0DI;EACE,iBAAA;AFy0DN;;AE10DI;EACE,iBAAA;AF60DN;;AE90DI;EACE,iBAAA;AFi1DN;;AEl1DI;EACE,iBAAA;AFq1DN;;AEt1DI;EACE,iBAAA;AFy1DN;;AE11DI;EACE,iBAAA;AF61DN;;AE91DI;EACE,iBAAA;AFi2DN;;AEl2DI;EACE,iBAAA;AFq2DN;;AEt2DI;EACE,iBAAA;AFy2DN;;AE12DI;EACE,iBAAA;AF62DN;;AE92DI;EACE,iBAAA;AFi3DN;;AEl3DI;EACE,iBAAA;AFq3DN;;AEt3DI;EACE,iBAAA;AFy3DN;;AE13DI;EACE,iBAAA;AF63DN;;AE93DI;EACE,iBAAA;AFi4DN;;AEl4DI;EACE,iBAAA;AFq4DN;;AEt4DI;EACE,iBAAA;AFy4DN;;AE14DI;EACE,iBAAA;AF64DN;;AE94DI;EACE,iBAAA;AFi5DN;;AEl5DI;EACE,iBAAA;AFq5DN;;AEt5DI;EACE,iBAAA;AFy5DN;;AE15DI;EACE,iBAAA;AF65DN;;AE95DI;EACE,iBAAA;AFi6DN;;AEl6DI;EACE,iBAAA;AFq6DN;;AEt6DI;EACE,iBAAA;AFy6DN;;AE16DI;EACE,iBAAA;AF66DN;;AE96DI;EACE,iBAAA;AFi7DN;;AEl7DI;EACE,iBAAA;AFq7DN;;AEt7DI;EACE,iBAAA;AFy7DN;;AE17DI;EACE,iBAAA;AF67DN;;AE97DI;EACE,iBAAA;AFi8DN;;AEl8DI;EACE,iBAAA;AFq8DN;;AEt8DI;EACE,iBAAA;AFy8DN;;AE18DI;EACE,iBAAA;AF68DN;;AE98DI;EACE,iBAAA;AFi9DN;;AEl9DI;EACE,iBAAA;AFq9DN;;AEt9DI;EACE,iBAAA;AFy9DN;;AE19DI;EACE,iBAAA;AF69DN;;AE99DI;EACE,iBAAA;AFi+DN;;AEl+DI;EACE,iBAAA;AFq+DN;;AEt+DI;EACE,iBAAA;AFy+DN;;AE1+DI;EACE,iBAAA;AF6+DN;;AE9+DI;EACE,iBAAA;AFi/DN;;AEl/DI;EACE,iBAAA;AFq/DN;;AEt/DI;EACE,iBAAA;AFy/DN;;AE1/DI;EACE,iBAAA;AF6/DN;;AE9/DI;EACE,iBAAA;AFigEN;;AElgEI;EACE,iBAAA;AFqgEN;;AEtgEI;EACE,iBAAA;AFygEN;;AE1gEI;EACE,iBAAA;AF6gEN;;AE9gEI;EACE,iBAAA;AFihEN;;AElhEI;EACE,iBAAA;AFqhEN;;AEthEI;EACE,iBAAA;AFyhEN;;AE1hEI;EACE,iBAAA;AF6hEN;;AE9hEI;EACE,iBAAA;AFiiEN;;AEliEI;EACE,iBAAA;AFqiEN;;AEtiEI;EACE,iBAAA;AFyiEN;;AE1iEI;EACE,iBAAA;AF6iEN;;AE9iEI;EACE,iBAAA;AFijEN;;AEljEI;EACE,iBAAA;AFqjEN;;AEtjEI;EACE,iBAAA;AFyjEN;;AE1jEI;EACE,iBAAA;AF6jEN;;AE9jEI;EACE,iBAAA;AFikEN;;AElkEI;EACE,iBAAA;AFqkEN;;AEtkEI;EACE,iBAAA;AFykEN;;AE1kEI;EACE,iBAAA;AF6kEN;;AE9kEI;EACE,iBAAA;AFilEN;;AEllEI;EACE,iBAAA;AFqlEN;;AEtlEI;EACE,iBAAA;AFylEN;;AE1lEI;EACE,iBAAA;AF6lEN;;AE9lEI;EACE,iBAAA;AFimEN;;AElmEI;EACE,iBAAA;AFqmEN;;AEtmEI;EACE,iBAAA;AFymEN;;AE1mEI;EACE,iBAAA;AF6mEN;;AE9mEI;EACE,iBAAA;AFinEN;;AElnEI;EACE,kBAAA;AFqnEN;;AEtnEI;EACE,iBAAA;AFynEN;;AE1nEI;EACE,iBAAA;AF6nEN;;AE9nEI;EACE,iBAAA;AFioEN;;AEloEI;EACE,iBAAA;AFqoEN;;AEtoEI;EACE,iBAAA;AFyoEN;;AE1oEI;EACE,iBAAA;AF6oEN;;AE9oEI;EACE,iBAAA;AFipEN;;AElpEI;EACE,iBAAA;AFqpEN;;AEtpEI;EACE,iBAAA;AFypEN;;AE1pEI;EACE,iBAAA;AF6pEN;;AE9pEI;EACE,kBAAA;AFiqEN;;AElqEI;EACE,kBAAA;AFqqEN;;AEtqEI;EACE,kBAAA;AFyqEN;;AE1qEI;EACE,kBAAA;AF6qEN;;AE9qEI;EACE,kBAAA;AFirEN;;AElrEI;EACE,kBAAA;AFqrEN;;AEtrEI;EACE,kBAAA;AFyrEN;;AE1rEI;EACE,kBAAA;AF6rEN;;AE9rEI;EACE,kBAAA;AFisEN;;AElsEI;EACE,kBAAA;AFqsEN;;AEtsEI;EACE,kBAAA;AFysEN;;AE1sEI;EACE,kBAAA;AF6sEN;;AE9sEI;EACE,kBAAA;AFitEN;;AEltEI;EACE,kBAAA;AFqtEN;;AEttEI;EACE,kBAAA;AFytEN;;AE1tEI;EACE,kBAAA;AF6tEN;;AE9tEI;EACE,kBAAA;AFiuEN;;AEluEI;EACE,kBAAA;AFquEN;;AEtuEI;EACE,kBAAA;AFyuEN;;AE1uEI;EACE,kBAAA;AF6uEN;;AE9uEI;EACE,kBAAA;AFivEN;;AElvEI;EACE,kBAAA;AFqvEN;;AEtvEI;EACE,kBAAA;AFyvEN;;AE1vEI;EACE,kBAAA;AF6vEN;;AE9vEI;EACE,kBAAA;AFiwEN;;AElwEI;EACE,kBAAA;AFqwEN;;AEtwEI;EACE,kBAAA;AFywEN;;AE1wEI;EACE,kBAAA;AF6wEN;;AE9wEI;EACE,kBAAA;AFixEN;;AElxEI;EACE,kBAAA;AFqxEN;;AEtxEI;EACE,kBAAA;AFyxEN;;AE1xEI;EACE,kBAAA;AF6xEN;;AE9xEI;EACE,kBAAA;AFiyEN;;AElyEI;EACE,kBAAA;AFqyEN;;AEtyEI;EACE,kBAAA;AFyyEN;;AE1yEI;EACE,kBAAA;AF6yEN;;AE9yEI;EACE,kBAAA;AFizEN;;AElzEI;EACE,kBAAA;AFqzEN;;AEtzEI;EACE,kBAAA;AFyzEN;;AE1zEI;EACE,kBAAA;AF6zEN;;AE9zEI;EACE,kBAAA;AFi0EN;;AEl0EI;EACE,kBAAA;AFq0EN;;AEt0EI;EACE,kBAAA;AFy0EN;;AE10EI;EACE,kBAAA;AF60EN;;AE90EI;EACE,kBAAA;AFi1EN;;AEl1EI;EACE,kBAAA;AFq1EN;;AEt1EI;EACE,kBAAA;AFy1EN;;AE11EI;EACE,kBAAA;AF61EN;;AE91EI;EACE,kBAAA;AFi2EN;;AEl2EI;EACE,kBAAA;AFq2EN;;AEt2EI;EACE,kBAAA;AFy2EN;;AE12EI;EACE,kBAAA;AF62EN;;AE92EI;EACE,kBAAA;AFi3EN;;AEl3EI;EACE,kBAAA;AFq3EN;;AEt3EI;EACE,kBAAA;AFy3EN;;AE13EI;EACE,kBAAA;AF63EN;;AE93EI;EACE,kBAAA;AFi4EN;;AEl4EI;EACE,kBAAA;AFq4EN;;AEt4EI;EACE,kBAAA;AFy4EN;;AE14EI;EACE,kBAAA;AF64EN;;AE94EI;EACE,kBAAA;AFi5EN;;AEl5EI;EACE,kBAAA;AFq5EN;;AEt5EI;EACE,kBAAA;AFy5EN;;AE15EI;EACE,kBAAA;AF65EN;;AE95EI;EACE,kBAAA;AFi6EN;;AEl6EI;EACE,kBAAA;AFq6EN;;AEt6EI;EACE,kBAAA;AFy6EN;;AE16EI;EACE,kBAAA;AF66EN;;AE96EI;EACE,kBAAA;AFi7EN;;AEl7EI;EACE,kBAAA;AFq7EN;;AEt7EI;EACE,kBAAA;AFy7EN;;AE17EI;EACE,kBAAA;AF67EN;;AE97EI;EACE,kBAAA;AFi8EN;;AEl8EI;EACE,kBAAA;AFq8EN;;AEt8EI;EACE,kBAAA;AFy8EN;;AE18EI;EACE,kBAAA;AF68EN;;AE98EI;EACE,kBAAA;AFi9EN;;AEl9EI;EACE,kBAAA;AFq9EN;;AEt9EI;EACE,kBAAA;AFy9EN;;AE19EI;EACE,kBAAA;AF69EN;;AE99EI;EACE,kBAAA;AFi+EN;;AEl+EI;EACE,kBAAA;AFq+EN;;AEt+EI;EACE,kBAAA;AFy+EN;;AE1+EI;EACE,kBAAA;AF6+EN;;AE9+EI;EACE,kBAAA;AFi/EN;;AEl/EI;EACE,kBAAA;AFq/EN;;AEt/EI;EACE,kBAAA;AFy/EN;;AE1/EI;EACE,kBAAA;AF6/EN;;AE9/EI;EACE,kBAAA;AFigFN;;AElgFI;EACE,kBAAA;AFqgFN;;AEtgFI;EACE,mBAAA;AFygFN;;AE1gFI;EACE,kBAAA;AF6gFN;;AE9gFI;EACE,kBAAA;AFihFN;;AElhFI;EACE,kBAAA;AFqhFN;;AEthFI;EACE,kBAAA;AFyhFN;;AE1hFI;EACE,kBAAA;AF6hFN;;AE9hFI;EACE,kBAAA;AFiiFN;;AEliFI;EACE,kBAAA;AFqiFN;;AEtiFI;EACE,kBAAA;AFyiFN;;AE1iFI;EACE,kBAAA;AF6iFN;;AE9iFI;EACE,kBAAA;AFijFN;;AEljFI;EACE,mBAAA;AFqjFN;;AEtjFI;EACE,mBAAA;AFyjFN;;AE1jFI;EACE,mBAAA;AF6jFN;;AE9jFI;EACE,mBAAA;AFikFN;;AElkFI;EACE,mBAAA;AFqkFN;;AEtkFI;EACE,mBAAA;AFykFN;;AE1kFI;EACE,mBAAA;AF6kFN;;AE9kFI;EACE,mBAAA;AFilFN;;AEllFI;EACE,mBAAA;AFqlFN;;AEtlFI;EACE,mBAAA;AFylFN;;AE1lFI;EACE,mBAAA;AF6lFN;;AE9lFI;EACE,mBAAA;AFimFN;;AElmFI;EACE,mBAAA;AFqmFN;;AEtmFI;EACE,mBAAA;AFymFN;;AE1mFI;EACE,mBAAA;AF6mFN;;AE9mFI;EACE,mBAAA;AFinFN;;AElnFI;EACE,mBAAA;AFqnFN;;AEtnFI;EACE,mBAAA;AFynFN;;AE1nFI;EACE,mBAAA;AF6nFN;;AE9nFI;EACE,mBAAA;AFioFN;;AEloFI;EACE,mBAAA;AFqoFN;;AEtoFI;EACE,mBAAA;AFyoFN;;AE1oFI;EACE,mBAAA;AF6oFN;;AE9oFI;EACE,mBAAA;AFipFN;;AElpFI;EACE,mBAAA;AFqpFN;;AEtpFI;EACE,mBAAA;AFypFN;;AE1pFI;EACE,mBAAA;AF6pFN;;AE9pFI;EACE,mBAAA;AFiqFN;;AElqFI;EACE,mBAAA;AFqqFN;;AEtqFI;EACE,mBAAA;AFyqFN;;AE1qFI;EACE,mBAAA;AF6qFN;;AE9qFI;EACE,mBAAA;AFirFN;;AElrFI;EACE,mBAAA;AFqrFN;;AEtrFI;EACE,mBAAA;AFyrFN;;AE1rFI;EACE,mBAAA;AF6rFN;;AE9rFI;EACE,mBAAA;AFisFN;;AElsFI;EACE,mBAAA;AFqsFN;;AEtsFI;EACE,mBAAA;AFysFN;;AE1sFI;EACE,mBAAA;AF6sFN;;AE9sFI;EACE,mBAAA;AFitFN;;AEltFI;EACE,mBAAA;AFqtFN;;AEttFI;EACE,mBAAA;AFytFN;;AE1tFI;EACE,mBAAA;AF6tFN;;AE9tFI;EACE,mBAAA;AFiuFN;;AEluFI;EACE,mBAAA;AFquFN;;AEtuFI;EACE,mBAAA;AFyuFN;;AE1uFI;EACE,mBAAA;AF6uFN;;AE9uFI;EACE,mBAAA;AFivFN;;AElvFI;EACE,mBAAA;AFqvFN;;AEtvFI;EACE,mBAAA;AFyvFN;;AE1vFI;EACE,mBAAA;AF6vFN;;AE9vFI;EACE,mBAAA;AFiwFN;;AElwFI;EACE,mBAAA;AFqwFN;;AEtwFI;EACE,mBAAA;AFywFN;;AE1wFI;EACE,mBAAA;AF6wFN;;AE9wFI;EACE,mBAAA;AFixFN;;AElxFI;EACE,mBAAA;AFqxFN;;AEtxFI;EACE,mBAAA;AFyxFN;;AE1xFI;EACE,mBAAA;AF6xFN;;AE9xFI;EACE,mBAAA;AFiyFN;;AElyFI;EACE,mBAAA;AFqyFN;;AEtyFI;EACE,mBAAA;AFyyFN;;AE1yFI;EACE,mBAAA;AF6yFN;;AE9yFI;EACE,mBAAA;AFizFN;;AElzFI;EACE,mBAAA;AFqzFN;;AEtzFI;EACE,mBAAA;AFyzFN;;AE1zFI;EACE,mBAAA;AF6zFN;;AE9zFI;EACE,mBAAA;AFi0FN;;AEl0FI;EACE,mBAAA;AFq0FN;;AEt0FI;EACE,mBAAA;AFy0FN;;AE10FI;EACE,mBAAA;AF60FN;;AE90FI;EACE,mBAAA;AFi1FN;;AEl1FI;EACE,mBAAA;AFq1FN;;AEt1FI;EACE,mBAAA;AFy1FN;;AE11FI;EACE,mBAAA;AF61FN;;AE91FI;EACE,mBAAA;AFi2FN;;AEl2FI;EACE,mBAAA;AFq2FN;;AEt2FI;EACE,mBAAA;AFy2FN;;AE12FI;EACE,mBAAA;AF62FN;;AE92FI;EACE,mBAAA;AFi3FN;;AEl3FI;EACE,mBAAA;AFq3FN;;AEt3FI;EACE,mBAAA;AFy3FN;;AE13FI;EACE,mBAAA;AF63FN;;AE93FI;EACE,mBAAA;AFi4FN;;AEl4FI;EACE,mBAAA;AFq4FN;;AEt4FI;EACE,mBAAA;AFy4FN;;AE14FI;EACE,mBAAA;AF64FN;;AE94FI;EACE,mBAAA;AFi5FN;;AEl5FI;EACE,mBAAA;AFq5FN;;AEt5FI;EACE,mBAAA;AFy5FN;;AE15FI;EACE,oBAAA;AF65FN;;AE95FI;EACE,eAAA;AFi6FN;;AEl6FI;EACE,eAAA;AFq6FN;;AEt6FI;EACE,eAAA;AFy6FN;;AE16FI;EACE,eAAA;AF66FN;;AE96FI;EACE,eAAA;AFi7FN;;AEl7FI;EACE,eAAA;AFq7FN;;AEt7FI;EACE,eAAA;AFy7FN;;AE17FI;EACE,eAAA;AF67FN;;AE97FI;EACE,eAAA;AFi8FN;;AEl8FI;EACE,eAAA;AFq8FN;;AEt8FI;EACE,gBAAA;AFy8FN;;AE18FI;EACE,gBAAA;AF68FN;;AE98FI;EACE,gBAAA;AFi9FN;;AEl9FI;EACE,gBAAA;AFq9FN;;AEt9FI;EACE,gBAAA;AFy9FN;;AE19FI;EACE,gBAAA;AF69FN;;AE99FI;EACE,gBAAA;AFi+FN;;AEl+FI;EACE,gBAAA;AFq+FN;;AEt+FI;EACE,gBAAA;AFy+FN;;AE1+FI;EACE,gBAAA;AF6+FN;;AE9+FI;EACE,gBAAA;AFi/FN;;AEl/FI;EACE,gBAAA;AFq/FN;;AEt/FI;EACE,gBAAA;AFy/FN;;AE1/FI;EACE,gBAAA;AF6/FN;;AE9/FI;EACE,gBAAA;AFigGN;;AElgGI;EACE,gBAAA;AFqgGN;;AEtgGI;EACE,gBAAA;AFygGN;;AE1gGI;EACE,gBAAA;AF6gGN;;AE9gGI;EACE,gBAAA;AFihGN;;AElhGI;EACE,gBAAA;AFqhGN;;AEthGI;EACE,gBAAA;AFyhGN;;AE1hGI;EACE,gBAAA;AF6hGN;;AE9hGI;EACE,gBAAA;AFiiGN;;AEliGI;EACE,gBAAA;AFqiGN;;AEtiGI;EACE,gBAAA;AFyiGN;;AE1iGI;EACE,gBAAA;AF6iGN;;AE9iGI;EACE,gBAAA;AFijGN;;AEljGI;EACE,gBAAA;AFqjGN;;AEtjGI;EACE,gBAAA;AFyjGN;;AE1jGI;EACE,gBAAA;AF6jGN;;AE9jGI;EACE,gBAAA;AFikGN;;AElkGI;EACE,gBAAA;AFqkGN;;AEtkGI;EACE,gBAAA;AFykGN;;AE1kGI;EACE,gBAAA;AF6kGN;;AE9kGI;EACE,gBAAA;AFilGN;;AEllGI;EACE,gBAAA;AFqlGN;;AEtlGI;EACE,gBAAA;AFylGN;;AE1lGI;EACE,gBAAA;AF6lGN;;AE9lGI;EACE,gBAAA;AFimGN;;AElmGI;EACE,gBAAA;AFqmGN;;AEtmGI;EACE,gBAAA;AFymGN;;AE1mGI;EACE,gBAAA;AF6mGN;;AE9mGI;EACE,gBAAA;AFinGN;;AElnGI;EACE,gBAAA;AFqnGN;;AEtnGI;EACE,gBAAA;AFynGN;;AE1nGI;EACE,gBAAA;AF6nGN;;AE9nGI;EACE,gBAAA;AFioGN;;AEloGI;EACE,gBAAA;AFqoGN;;AEtoGI;EACE,gBAAA;AFyoGN;;AE1oGI;EACE,gBAAA;AF6oGN;;AE9oGI;EACE,gBAAA;AFipGN;;AElpGI;EACE,gBAAA;AFqpGN;;AEtpGI;EACE,gBAAA;AFypGN;;AE1pGI;EACE,gBAAA;AF6pGN;;AE9pGI;EACE,gBAAA;AFiqGN;;AElqGI;EACE,gBAAA;AFqqGN;;AEtqGI;EACE,gBAAA;AFyqGN;;AE1qGI;EACE,gBAAA;AF6qGN;;AE9qGI;EACE,gBAAA;AFirGN;;AElrGI;EACE,gBAAA;AFqrGN;;AEtrGI;EACE,gBAAA;AFyrGN;;AE1rGI;EACE,gBAAA;AF6rGN;;AE9rGI;EACE,gBAAA;AFisGN;;AElsGI;EACE,gBAAA;AFqsGN;;AEtsGI;EACE,gBAAA;AFysGN;;AE1sGI;EACE,gBAAA;AF6sGN;;AE9sGI;EACE,gBAAA;AFitGN;;AEltGI;EACE,gBAAA;AFqtGN;;AEttGI;EACE,gBAAA;AFytGN;;AE1tGI;EACE,gBAAA;AF6tGN;;AE9tGI;EACE,gBAAA;AFiuGN;;AEluGI;EACE,gBAAA;AFquGN;;AEtuGI;EACE,gBAAA;AFyuGN;;AE1uGI;EACE,gBAAA;AF6uGN;;AE9uGI;EACE,gBAAA;AFivGN;;AElvGI;EACE,gBAAA;AFqvGN;;AEtvGI;EACE,gBAAA;AFyvGN;;AE1vGI;EACE,gBAAA;AF6vGN;;AE9vGI;EACE,gBAAA;AFiwGN;;AElwGI;EACE,gBAAA;AFqwGN;;AEtwGI;EACE,gBAAA;AFywGN;;AE1wGI;EACE,gBAAA;AF6wGN;;AE9wGI;EACE,gBAAA;AFixGN;;AElxGI;EACE,gBAAA;AFqxGN;;AEtxGI;EACE,gBAAA;AFyxGN;;AE1xGI;EACE,gBAAA;AF6xGN;;AE9xGI;EACE,gBAAA;AFiyGN;;AElyGI;EACE,gBAAA;AFqyGN;;AEtyGI;EACE,gBAAA;AFyyGN;;AE1yGI;EACE,gBAAA;AF6yGN;;AE9yGI;EACE,iBAAA;AFizGN;AE7zGE;EAoCA;IACE,aAAA;IACA,UAAA;IACA,mBAAA;EFqzGF;EElzGA;IACE,qBAAA;IACA,UAAA;IACA,YAAA;EFozGF;AACF;AEl2GE;EAmDA;IACE,YAAA;IACA,qBAAA;EFs0GF;EEn0GA;IACE,UAAA;IACA,mBAAA;EFq0GF;AACF;AAv/GA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AAy/GJ;AAv/GI;EAVJ;IAWQ,aAAA;EA0/GN;AACF;AAx/GI;EACI,oBAAA;AA0/GR;;AAt/GA;EACI,WAAA;EACA,YAAA;EACA,6DAAA;EACA,iDAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,yCAAA;AAy/GJ;AAv/GI;EACI,eAAA;EACA,aAAA;EACA,uBAAA;AAy/GR;AAt/GI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAw/GR;AAt/GQ;EACI,eAAA;EACA,YAAA;EACA,cAAA;AAw/GZ;AAp/GI;EACI,SAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAs/GR;AAn/GI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,iDAAA;EACA,kBAAA;AAq/GR;AAn/GQ;EACI,wCAAA;EACA,YAAA;AAq/GZ;AAn/GY;EACI,aC8JM;ADu1GtB;AAj/GQ;EACI,yCAAA;EACA,YAAA;AAm/GZ;AAj/GY;EACI,aCqJM;EDpJN,mDAAA;AAm/GhB;AAh/GY;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,wDAAA;EACA,0BAAA;EACA,2CAAA;AAk/GhB;AA7+GI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AA++GR;AA7+GQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AA++GZ;AA5+GQ;EACI,eAAA;AA8+GZ;AA1+GI;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;AA4+GR;AAz+GI;EACI,iBAAA;EACA,+CAAA;AA2+GR;AAx+GI;EACI,eAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,wCAAA;EACA,kDAAA;UAAA,0CAAA;EACA,iDAAA;EACA,gBAAA;EACA,oDAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,0CAAA;AA0+GR;AAx+GQ;EACI,YAAA;AA0+GZ;AAt+GI;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAw+GR;AAt+GQ;EACI,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,qEAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;AAw+GZ;AAp+GI;EACI,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAs+GR;AAp+GQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,+BAAA;EACA,oBAAA;EACA,2BAAA;AAs+GZ;AAn+GQ;EACI,WAAA;EACA,qCAAA;EACA,2CAAA;EACA,kBAAA;EACA,4BAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;AAq+GZ;AAn+GY;EACI,gCAAA;AAq+GhB;AAl+GY;EACI,qCAAA;EACA,oCAAA;EACA,4CAAA;AAo+GhB;AAl+GgB;EACI,cCgBE;ADo9GtB;AA99GI;EACI,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAg+GR;AA99GQ;EACI,YAAA;EACA,2CAAA;AAg+GZ;AA79GQ;EACI,cCLU;EDMV,yBAAA;AA+9GZ;AA59GQ;EACI,eAAA;AA89GZ;AA19GI;EACI,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA49GR;AAz9GI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,kDAAA;EACA,kBAAA;EACA,aAAA;EACA,+CAAA;EACA,2BAAA;EACA,wBAAA;EACA,gBAAA;AA29GR;AAz9GQ;EACI,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AA29GZ;AAz9GQ;EACI,eAAA;EACA,gCAAA;EACA,yBAAA;AA29GZ;AAx9GQ;EACI,0CAAA;AA09GZ;AAv9GQ;EACI,sDAAA;EACA,uBAAA;EACA,uCAAA;EACA,0BAAA;AAy9GZ;AAv9GY;EACI,cC/DM;EDgEN,qBAAA;AAy9GhB;AAt9GY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,gFAAA;EACA,oBAAA;AAw9GhB;AAn9GY;EACI,oCAAA;AAq9GhB;;AA/8GA;EACI;IAAO,uBAAA;EAm9GT;EAl9GE;IAAK,yBAAA;EAq9GP;AACF;AAl9GA;EACI;IACI,UAAA;IACA,uCAAA;EAo9GN;EAl9GE;IACI,UAAA;IACA,iCAAA;EAo9GN;AACF;AAp8GA;EACI,cAAA;EACA,WAAA;EAGA,4BAAA;EACA,8BAAA;EACA,+BAAA;AAo8GJ;AAl8GI;EATJ;IAUQ,+BAAA;IACA,sCAAA;IACA,6BAAA;EAq8GN;AACF;AAn8GI;EAfJ;IAgBQ,+BAAA;EAs8GN;AACF;AAp8GI;EACI,6BAAA;AAs8GR;AAn8GI;EACI,2BAAA;EACA,6BAAA;AAq8GR;AAl8GI;EACI,mHAAA;EACA,iIAAA;EACA,iDAAA;AAo8GR;AA97GI;EACI,2BAAA;EACA,6BAAA;AAg8GR;;AA37GA;EACI,iBAAA;EAAA,8CAAA;EACA,kBAAA;EAAA,iDAAA;EACA,wBAAA;EAAA,qDAAA;EACA,iDAAA;AA87GJ","sourcesContent":["\n$color-name-list: (\n  \"primary-dark\",\n  \"aqua-green\",\n  \"green\",\n  \"green-dark\",\n  \"green-light\",\n  \"purple\",\n  \"red\",\n  \"red-light\",\n  \"orange\",\n  \"blue\",\n  \"blue-grey\",\n  \"blue-2\",\n  \"yellow\",\n  \"gray\",\n  \"light-green\",\n  \"pink\",\n  \"blue-high\",\n  \"blue-2-high\"\n);\n\n$tooltip-color-name-list: ( \n  \"aqua-green\",\n  \"green\",\n  \"green-dark\",\n  \"purple\",\n  \"red\",\n  \"red-light\",\n  \"orange\",\n  \"blue\",\n  \"blue-grey\",\n  \"blue-2\",\n  \"blue-3\",\n  \"blue-dark\",\n  \"yellow\",\n  \"gray\",\n  \"light-green\",\n  \"pink\",\n  \"accent-blue\",\n  \"accent-red\",\n  \"accent-orange\",\n  \"accent-green\",\n  \"accent-green-2\",\n  \"accent-yellow\"\n);\n\n$banner-color-name-list: (\n  \"primary-dark\",\n  \"secondary-dark\",\n  \"accent-1\",\n  \"accent-2\",\n  \"accent-3\",\n);\n\n$tooltip-colors: (\n  \"aqua-green\": #3BCFB2,\n  \"green\": #54ebae,\n  \"green-dark\": #51d858,\n  \"purple\": #292F69,\n  \"red\": #692929,\n  \"red-light\": #D0021B,\n  \"orange\":  #DD5944,\n  \"blue\": #4b658b,\n  \"blue-3\": #4F99EA,\n  \"blue-grey\": #294369,\n  \"blue-2\": #3165B2,\n  \"blue-dark\": #3965c7,\n  \"yellow\": #f8df71,\n  \"gray\": rgba(141,141,141,0.85),\n  \"light-green\": #71C187,\n  \"pink\": #572969,\n  \"accent-blue\": #1B57D1,\n  \"accent-red\": #d11b1b,\n  \"accent-orange\": #d1641b,\n  \"accent-green\": #1bd194,\n  \"accent-green-2\": #39d11b,\n  \"accent-yellow\": #f7e70f,\n);\n\n$banner-colors: (\n  \"primary-dark\": #152935,\n  \"secondary-dark\": #29694F,\n  \"accent-1\": #1B57D1,\n  \"accent-2\": #FF832B,\n  \"accent-3\": #692929\n);\n\n$attribute-colors: (\n  \"primary-dark\": #1B1E26,\n  \"aqua-green\": #3BCFB2,\n  \"green\": #29694F,\n  \"green-dark\": #2A624A,\n  \"green-light\": #579A6E,\n  \"purple\": #292F69,\n  \"red\": #692929,\n  \"red-light\": #D0021B,\n  \"orange\":  #DD5944,\n  \"blue\": #294369,\n  \"blue-grey\": #294369,\n  \"blue-2\": #3165B2,\n  \"yellow\": #19160C,\n  \"gray\": rgba(141,141,141,0.85),\n  \"light-green\": #71C187,\n  \"pink\": #572969,\n  \"blue-high\": #F6FAFE,\n  \"blue-2-high\": #F6FAFE\n);\n\n$attribute-hover-colors: (\n  \"primary-dark\": #FF832B,\n  \"aqua-green\": #E2FFF5,\n  \"green\": #F6FEF9,\n  \"green-dark\": #F6FEF9,\n  \"green-light\": #F6FEF9,\n  \"purple\": #F6F7FE,\n  \"red\": #FEF6F6,\n  \"red-light\": #FEF6F6,\n  \"orange\": #FEF6F6,\n  \"blue\": #F6FAFE,\n  \"blue-grey\": #f5f5f5,\n  \"blue-2\": #F6FAFE,\n  \"yellow\": #FBFEDC,\n  \"gray\": rgba(241,241,241,0.87),\n  \"light-green\": #F6FEF9,\n  \"pink\": #FAF6FE,\n  \"blue-high\": #294369,\n  \"blue-2-high\": #3165B2\n);\n\n$attribute-background-colors: (\n  \"primary-dark\": #FFFFFF,\n  \"aqua-green\": #E2FFF5,\n  \"green\": #F6FEF9,\n  \"green-dark\": #F6FEF9,\n  \"green-light\": #F6FEF9,\n  \"purple\": #F6F7FE,\n  \"red\": #FEF6F6,\n  \"red-light\": #FEF6F6,\n  \"orange\":  #FEF6F6,\n  \"blue\": #F6FAFE,\n  \"blue-grey\": #f5f5f5,\n  \"blue-2\": #F6FAFE,\n  \"yellow\": #FBFEDC,\n  \"gray\": rgba(241,241,241,0.87),\n  \"light-green\": #F6FEF9,\n  \"pink\": #FAF6FE,\n  \"blue-high\": #294369,\n  \"blue-2-high\": #3165B2\n);\n\n@each $color-name in $color-name-list {\n  .color-#{$color-name} {\n    color: map-get($attribute-colors, $color-name);\n  }\n}\n","@import 'scss/_variables';\n@import 'scss/_colors';\n@import 'scss/_mixins';\n\n.perplexity-sidebar-wrapper {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    z-index: 9999;\n    display: flex;\n    align-items: flex-start;\n    pointer-events: none;\n\n    @media screen and (max-width: 768px) {\n        display: none;\n    }\n\n    & > * {\n        pointer-events: auto;\n    }\n}\n\n.perplexity-sidebar {\n    width: 72px;\n    height: 100%;\n    background: linear-gradient(180deg, #0a0b0d 0%, #000000 100%);\n    border-right: 1px solid rgba(255, 255, 255, 0.08);\n    display: flex;\n    flex-direction: column;\n    z-index: 10000;\n    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.5);\n\n    &__top {\n        padding: 20px 0;\n        display: flex;\n        justify-content: center;\n    }\n\n    &__logo {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        img {\n            max-width: 40px;\n            height: auto;\n            display: block;\n        }\n    }\n\n    &__nav {\n        flex: 1;\n        padding: 10px 4px;\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n    }\n\n    &__nav-item {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 10px 4px;\n        border-radius: 12px;\n        cursor: pointer;\n        position: relative;\n        color: rgba(255, 255, 255, 0.75);\n        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n        text-align: center;\n\n        &:hover {\n            background-color: transparent !important;\n            color: white;\n\n            .perplexity-sidebar__item-icon svg {\n                fill: $secondary-color-500;\n            }\n        }\n\n        &.active {\n            background-color: rgba($secondary-color-500, 0.12);\n            color: white;\n\n            .perplexity-sidebar__item-icon svg {\n                fill: $secondary-color-500;\n                filter: drop-shadow(0 0 8px rgba($secondary-color-500, 0.5));\n            }\n\n            &::after {\n                content: \"\";\n                position: absolute;\n                left: 0;\n                top: 20%;\n                bottom: 20%;\n                width: 3px;\n                background: linear-gradient(to bottom, $secondary-color-500, #4A90E2);\n                border-radius: 0 4px 4px 0;\n                box-shadow: 0 0 10px rgba($secondary-color-500, 0.6);\n            }\n        }\n    }\n\n    &__item-icon {\n        width: 26px;\n        height: 26px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: 2px;\n        border-radius: 8px;\n        transition: all 0.3s ease;\n        \n        svg {\n            width: 22px;\n            height: 22px;\n            fill: currentColor;\n        }\n\n        .material-icons {\n            font-size: 22px;\n        }\n    }\n\n    &__item-label {\n        font-size: 9px;\n        font-weight: 600;\n        line-height: 1.1;\n        white-space: pre-line;\n        text-transform: uppercase;\n        letter-spacing: 0.02em;\n    }\n\n    &__bottom {\n        padding: 16px 4px;\n        border-top: 1px solid rgba(255, 255, 255, 0.05);\n    }\n\n    &__flyout {\n        position: fixed;\n        top: 0;\n        left: 72px;\n        height: 100vh;\n        width: 0;\n        margin: 0;\n        background-color: rgba(22, 24, 28, 0.95);\n        backdrop-filter: blur(20px) saturate(180%);\n        border-right: 1px solid rgba(255, 255, 255, 0.08);\n        overflow: hidden;\n        transition: width 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n        display: flex;\n        flex-direction: column;\n        z-index: 9999;\n        box-shadow: 10px 0 40px rgba(0, 0, 0, 0.4);\n\n        &.open {\n            width: 280px;\n        }\n    }\n\n    &__flyout-header {\n        padding: 30px 24px 12px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        h3 {\n            margin: 0;\n            color: white;\n            font-size: 18px;\n            font-weight: 800;\n            letter-spacing: -0.01em;\n            background: linear-gradient(to right, #fff, rgba(255, 255, 255, 0.7));\n            -webkit-background-clip: text;\n            background-clip: text;\n            -webkit-text-fill-color: transparent;\n        }\n    }\n\n    &__search-container {\n        padding: 0 20px 16px;\n        position: relative;\n        display: flex;\n        align-items: center;\n\n        .material-icons {\n            position: absolute;\n            left: 32px;\n            top: 50%;\n            transform: translateY(-50%);\n            font-size: 18px;\n            color: rgba(255, 255, 255, 0.3);\n            pointer-events: none;\n            transition: color 0.2s ease;\n        }\n\n        input {\n            width: 100%;\n            background: rgba(255, 255, 255, 0.04);\n            border: 1px solid rgba(255, 255, 255, 0.08);\n            border-radius: 8px;\n            padding: 10px 12px 10px 38px;\n            color: white;\n            font-size: 13px;\n            font-family: inherit;\n            transition: all 0.2s ease;\n            outline: none;\n\n            &::placeholder {\n                color: rgba(255, 255, 255, 0.25);\n            }\n\n            &:focus {\n                background: rgba(255, 255, 255, 0.07);\n                border-color: rgba($secondary-color-500, 0.4);\n                box-shadow: 0 0 0 2px rgba($secondary-color-500, 0.1);\n\n                & + .material-icons {\n                    color: $secondary-color-500;\n                }\n            }\n        }\n    }\n\n    &__pin-btn {\n        background: transparent;\n        border: none;\n        color: rgba(255, 255, 255, 0.3);\n        cursor: pointer;\n        padding: 4px;\n        border-radius: 4px;\n        transition: all 0.2s ease;\n\n        &:hover {\n            color: white;\n            background-color: rgba(255, 255, 255, 0.05);\n        }\n\n        &.pinned {\n            color: $secondary-color-500;\n            transform: rotate(-45deg);\n        }\n\n        .material-icons {\n            font-size: 18px;\n        }\n    }\n\n    &__flyout-content {\n        flex: 1;\n        padding: 12px;\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n    }\n\n    &__link-item {\n        display: flex;\n        align-items: center;\n        gap: 14px;\n        padding: 14px 18px;\n        border-radius: 10px;\n        text-decoration: none !important;\n        color: rgba(255, 255, 255, 0.7);\n        font-size: 14px;\n        font-weight: 500;\n        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n        position: relative;\n        margin: 0 4px;\n        border-bottom: 2px solid transparent !important;\n        box-shadow: none !important;\n        outline: none !important;\n        overflow: hidden;\n\n        span {\n            flex: 1;\n            white-space: normal;\n            word-break: break-word;\n            line-height: 1.4;\n        }\n        .material-icons {\n            font-size: 20px;\n            color: rgba(255, 255, 255, 0.25);\n            transition: all 0.3s ease;\n        }\n\n        &:visited {\n            color: rgba(255, 255, 255, 0.7) !important;\n        }\n\n        &:hover {\n            background-color: rgba(255, 255, 255, 0.03) !important;\n            color: white !important;\n            border-bottom-color: $secondary-color-500 !important;\n            transform: translateX(4px);\n\n            .material-icons {\n                color: $secondary-color-500;\n                transform: scale(1.1);\n            }\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                inset: 0;\n                border-radius: 10px;\n                background: linear-gradient(90deg, rgba($secondary-color-500, 0.05) 0%, transparent 100%);\n                pointer-events: none;\n            }\n        }\n\n        &.is-loading {\n            .material-icons {\n                animation: rotate 2s linear infinite;\n            }\n        }\n    }\n}\n\n@keyframes rotate {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n}\n\n\n@keyframes tooltipEnter {\n    from {\n        opacity: 0;\n        transform: translateX(10px) scale(0.95);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0) scale(1);\n    }\n}\n\n// Layout spacing variables\n$sidebar-mini-width: 72px;\n$sidebar-full-width: 352px;\n$content-internal-padding: 16px; // Standardized internal alignment gap\n// 50px matches .research__form padding\n$research-form-padding-desktop: 50px;\n$research-form-padding-tablet: 15px; // Matches < 768px\n$research-form-padding-mobile: 10px; // Matches < 480px\n\n// 54px Total Gap: Content (16px) + NavBar (10px) + Options (16px) + 12px Nudge\n$header-left-gap: $content-internal-padding + 10px + 16px + 12px; \n$header-right-gap: 50px; // Matches right side padding for name display\n\n.perplexity-layout {\n    display: block;\n    width: 100%;\n\n    // Set layout variables globally for child components to use\n    --layout-sidebar-width: #{$sidebar-mini-width};\n    --layout-content-padding: #{$content-internal-padding};\n    --layout-research-padding: #{$research-form-padding-desktop};\n\n    @media screen and (max-width: 768px) {\n        --layout-research-padding: #{$research-form-padding-tablet};\n        --layout-sidebar-width: 0px !important;\n        --layout-content-padding: 0px;\n    }\n\n    @media screen and (max-width: 480px) {\n        --layout-research-padding: #{$research-form-padding-mobile};\n    }\n\n    &.sidebar-pinned {\n        --layout-sidebar-width: #{$sidebar-full-width};\n    }\n\n    &.no-sidebar {\n        --layout-sidebar-width: 0px;\n        --layout-content-padding: 0px;\n    }\n\n    .is-sticky {\n        left: calc(var(--layout-sidebar-width) + var(--layout-content-padding) + var(--layout-research-padding)) !important;\n        width: calc(100% - (var(--layout-sidebar-width) + var(--layout-content-padding) + var(--layout-research-padding) * 2)) !important;\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        \n        // Adjust for scrollbar if needed, but usually calc(100% - offsets) is enough\n        // if theOffsets include both sides.\n    }\n\n    &.no-sidebar {\n        --layout-sidebar-width: 0px;\n        --layout-content-padding: 0px;\n    }\n}\n\n\n.perplexity-content {\n    margin-left: var(--layout-sidebar-width, #{$sidebar-mini-width});\n    padding-left: var(--layout-content-padding, #{$content-internal-padding});\n    width: calc(100% - var(--layout-sidebar-width, #{$sidebar-mini-width}));\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n\n",":root {\n  /* Primary colors */\n  --primary-color-100: #779BB0;\n  --primary-color-300: #454B56;\n  --primary-color-400: #294369;\n  --primary-color-500: #152935;\n  --primary-color-500-50: #2e5c9a80;\n  --primary-color-600: #1c1f27;\n  --primary-color-650: #1b1e26;\n  --primary-color-700: #1a2634;\n\n  --secondary-color-500: #006cff;\n  // --rs-btn-primary-bg: var(--primary-color-500);\n  --rs-gray-0: #fff;\n  --rs-gray-50: #f7f7fa;\n  --rs-gray-100: var(--primary-color-dark-100);\n  --rs-gray-200: var(--primary-color-dark-200);\n  --rs-gray-300: var(--primary-color-dark-300);\n  --rs-gray-400: var(--primary-color-dark-400);\n  --rs-gray-500: var(--primary-color-dark-500);\n  --rs-gray-600: var(--primary-color-dark-600);\n  --rs-gray-700: var(--primary-color-dark-700);\n  --rs-gray-800: var(--primary-color-dark-800);\n  --rs-gray-900: var(--primary-color-700);\n  --rs-primary-50: #f2faff;\n  --rs-primary-100: var(--primary-color-dark-100);\n  --rs-primary-200: var(--primary-color-dark-200);\n  --rs-primary-400: var(--primary-color-400);\n  --rs-primary-500: var(--primary-color-500);\n  --rs-primary-600: var(--primary-color-600);\n  --rs-primary-700: var(--primary-color-700);\n  --rs-primary-800: var(--primary-color-dark-800);\n  --rs-primary-900: var(--primary-color-dark-900);\n  --rs-bg-overlay: var(--primary-color-light-500);\n  --rs-calendar-date-selected-text: var(--primary-color-light-500);\n  /* Accent colors */\n  --accent-color-1: #1B57D1;\n  --accent-color-2: #FF832B;\n  --accent-color-3: #fe7b06;\n  \n  /* Secondary colors */\n  --secondary-color-300: #71C187;\n  --secondary-color-300-50: #71c18780;\n  \n  /* Dark colors */\n  --primary-color-dark-900: #000000;\n  --primary-color-dark-850: #040D0B;\n  --primary-color-dark-800: #152935;\n  --primary-color-dark-750: #1C1F27;\n  --primary-color-dark-720: #272727;\n  --primary-color-dark-700: #353333;\n  --primary-color-dark-650: #383c42;\n  --primary-color-dark-610: #393b42;\n  --primary-color-dark-600: #3F4A50;\n  --primary-color-dark-550: #484848;\n  --primary-color-dark-500: #535353;\n  --primary-color-dark-400: #646464;\n  --primary-color-dark-375: #676767;\n  --primary-color-dark-350: #736F6F;\n  --primary-color-dark-300: #818078;\n  --primary-color-dark-200: #AAAAAA;\n  --primary-color-dark-100: #BCBCBC;\n  \n  /* Light colors */\n  --primary-color-light-500: #FFFFFF;\n  --primary-color-light-300: #F4F4F4;\n  --primary-color-light-200: #F5F5F5;\n  --primary-color-light-150: #F6FAFE;\n  --primary-color-light-opacity-59: rgba(255, 255, 255, .59);\n  --primary-color-light-opacity-45: rgba(255, 255, 255, .45);\n  --primary-color-light-opacity-2: rgba(255, 255, 255, .2);\n  \n  /* Alert and danger colors */\n  --alert-color-1: #DA1E28;\n  --alert-color-2: #24A148;\n  --alert-color-3: #4a944f;\n  --warning-color-1: #f1c755;\n  --danger-color-300: #C17D71;\n  --danger-color-500: #D7563F;\n  \n  /* Brand colors */\n  --facebook-brand-color: #1A77F3;\n  --linkedin-brand-color: #007DBB;\n  --twitter-brand-color: #03A9F4;\n  \n  /* Box shadows */\n  --box-shadow-primary-5: rgba(0, 0, 0, 0.5);\n  --box-shadow-primary-7: rgba(0, 0, 0, 0.07);\n  --box-shadow-primary-12: rgba(0, 0, 0, 0.12);\n  --box-shadow-primary-13: rgba(0, 0, 0, 0.13);\n  --box-shadow-primary-14: rgba(0, 0, 0, 0.14);\n  --box-shadow-primary-16: rgba(0, 0, 0, 0.16);\n  --box-shadow-primary-18: rgba(0, 0, 0, 0.18);\n  --box-shadow-primary-19: rgba(0, 0, 0, 0.19);\n  --box-shadow-primary-22: rgba(0, 0, 0, 0.22);\n  --box-shadow-primary-25: rgba(0, 0, 0, 0.25);\n  --box-shadow-primary-57: rgba(0, 0, 0, 0.57);\n  \n  /* Card shadows */\n  --card-view-box-shadow: 0 2px 6px 0 rgba(109, 109, 109, 0.08);\n  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(109, 109, 109, 0.5);\n  --card-view-box-shadow-light: -1px 1px 8px rgba(0, 0, 0, 0.11);\n  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(0, 0, 0, 0.28);\n\n  --z-index-close: -1;\n  --z-index-popup: 12;\n  --z-index-tooltip: 11;\n  --z-index-popup-light: 10;\n  --z-index-sticky: 9;\n}\n\n/* Dark Theme - Reversed/Adapted Colors */\n:root[data-theme=\"dark\"] {\n  /* Primary colors - Reversed for dark theme */\n  --primary-color-100: #BCBCBC;        /* Was #779BB0 - now light grey */\n  --primary-color-300: #AAAAAA;        /* Was #454B56 - now medium grey */\n  --primary-color-400: #779BB0;        /* Was #294369 - now original 100 */\n  --primary-color-500: #FFFFFF;        /* Was #152935 - now white for text */\n  --primary-color-500-50: rgba(188, 188, 188, 0.5); /* Adapted opacity */\n  --primary-color-600: #F4F4F4;        /* Was #1c1f27 - now light */\n  --primary-color-650: #F5F5F5;        /* Was #1b1e26 - now light */\n  --primary-color-700: #F6FAFE;        /* Was #1a2634 - now lightest */\n\n  /* Mirror rs- (design-system) variables for dark theme so overrides\n     in :root are reversed appropriately in dark mode. These reference\n     the dark-theme primary/light variables defined above. */\n  --rs-gray-0: var(--primary-color-light-500);\n  --rs-gray-50: var(--primary-color-light-300);\n  --rs-gray-100: var(--primary-color-dark-100);\n  --rs-gray-200: var(--primary-color-dark-200);\n  --rs-gray-300: var(--primary-color-dark-300);\n  --rs-gray-400: var(--primary-color-dark-400);\n  --rs-gray-500: var(--primary-color-dark-500);\n  --rs-gray-600: var(--primary-color-dark-600);\n  --rs-gray-700: var(--primary-color-dark-700);\n  --rs-gray-800: var(--primary-color-dark-800);\n  --rs-gray-900: var(--primary-color-700);\n  --rs-primary-50: var(--primary-color-light-150);\n  --rs-primary-100: var(--primary-color-dark-100);\n  --rs-primary-200: var(--primary-color-dark-200);\n  --rs-primary-400: var(--primary-color-400);\n  --rs-primary-500: var(--primary-color-500);\n  --rs-primary-600: var(--primary-color-600);\n  --rs-primary-700: var(--primary-color-700);\n  --rs-primary-800: var(--primary-color-dark-800);\n  --rs-primary-900: var(--primary-color-dark-900);\n  --rs-bg-overlay: var(--primary-color-light-500);\n  --rs-calendar-date-selected-text: var(--primary-color-light-500);\n  \n  /* Accent colors - Brightened for dark backgrounds */\n  --accent-color-1: #4A7FE7;          /* Lightened blue */\n  --accent-color-2: #FF9A4D;          /* Lightened orange */\n  --accent-color-3: #FF8C2B;          /* Lightened orange variant */\n  \n  --secondary-color-500: #006cff;\n  --secondary-color-300: #8FD4A4;     /* Lightened green */\n  --secondary-color-300-50: rgba(143, 212, 164, 0.5);\n  \n  /* Dark colors become background/surface colors */\n  --primary-color-dark-900: #FFFFFF;   /* Reversed - now white */\n  --primary-color-dark-850: #F6FAFE;   /* Light background */\n  --primary-color-dark-800: #F5F5F5;   /* Light surface */\n  --primary-color-dark-750: #F4F4F4;   /* Light elevated */\n  --primary-color-dark-720: #EEEEEE;   /* Light hover */\n  --primary-color-dark-700: #E8E8E8;   /* Light active */\n  --primary-color-dark-650: #E0E0E0;   /* Light border */\n  --primary-color-dark-610: #DDDDDD;   /* Light border variant */\n  --primary-color-dark-600: #D8D8D8;   /* Light subtle */\n  --primary-color-dark-550: #CCCCCC;   /* Medium light */\n  --primary-color-dark-500: #BBBBBB;   /* Medium */\n  --primary-color-dark-400: #AAAAAA;   /* Medium dark */\n  --primary-color-dark-375: #999999;   /* Medium dark variant */\n  --primary-color-dark-350: #888888;   /* Dark */\n  --primary-color-dark-300: #777777;   /* Darker */\n  --primary-color-dark-200: #555555;   /* Very dark */\n  --primary-color-dark-100: #454B56;   /* Darkest - original 300 */\n  \n  /* Light colors become dark backgrounds */\n  --primary-color-light-500: #000000;  /* Main dark background */\n  --primary-color-light-300: #040D0B;  /* Dark secondary */\n  --primary-color-light-200: #152935;  /* Dark tertiary */\n  --primary-color-light-150: #1C1F27;  /* Dark elevated */\n  --primary-color-light-opacity-59: rgba(0, 0, 0, 0.59);\n  --primary-color-light-opacity-45: rgba(0, 0, 0, 0.45);\n  --primary-color-light-opacity-2: rgba(0, 0, 0, 0.2);\n  \n  /* Alert and danger colors - Enhanced for dark */\n  --alert-color-1: #FF4757;           /* Brighter red */\n  --alert-color-2: #2ECC71;           /* Brighter green */\n  --alert-color-3: #27AE60;           /* Brighter green variant */\n  --warning-color-1: #F39C12;         /* Brighter yellow */\n  --danger-color-300: #E74C3C;        /* Brighter danger */\n  --danger-color-500: #C0392B;        /* Darker danger */\n  \n  /* Brand colors - Lightened for dark backgrounds */\n  --facebook-brand-color: #4267B2;\n  --linkedin-brand-color: #0077B5;\n  --twitter-brand-color: #1DA1F2;\n  \n  /* Box shadows - Adapted for dark theme */\n  --box-shadow-primary-5: rgba(255, 255, 255, 0.1);\n  --box-shadow-primary-7: rgba(255, 255, 255, 0.07);\n  --box-shadow-primary-12: rgba(255, 255, 255, 0.12);\n  --box-shadow-primary-13: rgba(255, 255, 255, 0.13);\n  --box-shadow-primary-14: rgba(255, 255, 255, 0.14);\n  --box-shadow-primary-16: rgba(255, 255, 255, 0.16);\n  --box-shadow-primary-18: rgba(255, 255, 255, 0.18);\n  --box-shadow-primary-19: rgba(255, 255, 255, 0.19);\n  --box-shadow-primary-22: rgba(255, 255, 255, 0.22);\n  --box-shadow-primary-25: rgba(255, 255, 255, 0.25);\n  --box-shadow-primary-57: rgba(255, 255, 255, 0.1);\n  \n  /* Card shadows - Dark theme */\n  --card-view-box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0.08);\n  --card-view-box-shadow-hover: 0 3px 7px 0 rgba(255, 255, 255, 0.15);\n  --card-view-box-shadow-light: -1px 1px 8px rgba(255, 255, 255, 0.11);\n  --card-view-box-shadow-light-hover: -1px 1px 8px rgba(255, 255, 255, 0.25);\n  --z-index-popup: 10;\n  --z-index-sticky: 9;\n}\n\n$primary-color-100: #779BB0;\n$primary-color-300: #454B56;\n$primary-color-500: #152935;\n$primary-color-500-50: #2e5c9a80;\n$primary-color-600: #1c1f27;\n$primary-color-650: #1b1e26;\n$primary-color-700: #1a2634;\n$primary-color-400: #294369;\n\n$accent-color-1: #1B57D1;\n$accent-color-2: #FF832B;\n$accent-color-3: #fe7b06;\n\n$secondary-color-500: #006cff;\n$secondary-color-300: #71C187;\n$secondary-color-300-50: #71c18780;\n\n$primary-color-dark-900: #000000;\n$primary-color-dark-850: #040D0B;\n$primary-color-dark-800: #152935;\n$primary-color-dark-750: #1C1F27;\n$primary-color-dark-720: #272727;\n$primary-color-dark-700: #353333;\n$primary-color-dark-650: #383c42;\n$primary-color-dark-610: #393b42;\n$primary-color-dark-600: #3F4A50;\n$primary-color-dark-550: #484848;\n$primary-color-dark-500: #535353;\n$primary-color-dark-400: #646464;\n$primary-color-dark-375: #676767;\n$primary-color-dark-350: #736F6F;\n$primary-color-dark-300: #818078;\n$primary-color-dark-200: #AAAAAA;\n$primary-color-dark-100: #BCBCBC;\n\n// primary light color\n$primary-color-light-500: #FFFFFF;\n\n$primary-color-light-300: #F4F4F4;\n$primary-color-light-200: #F5F5F5;\n$primary-color-light-150: #F6FAFE;\n$alert-color-3: #4a944f;\n$alert-color-2: #24A148;\n\n$primary-color-light-opacity-59: rgba(255, 255, 255, .59);\n$primary-color-light-opacity-45: rgba(255, 255, 255, .45);\n$primary-color-light-opacity-2: rgba(255, 255, 255, .2);\n\n\n// danger color\n\n$alert-color-1: #DA1E28;\n$warning-color-1: #f1c755;\n$danger-color-300: #C17D71;\n$danger-color-500: #D7563F;\n\n\n// brand colors\n$facebook-brand-color: #1A77F3;\n$linkedin-brand-color: #007DBB;\n$twitter-brand-color: #03A9F4;\n\n$box-shadow-primary-5: rgba(0, 0, 0, 0.5);\n$box-shadow-primary-7: rgba(0, 0, 0, 0.07);\n$box-shadow-primary-18: rgba(0,0,0,0.18);\n$box-shadow-primary-14: rgba(0, 0, 0, 0.14);\n$box-shadow-primary-16: rgba(0, 0, 0, 0.16);\n$box-shadow-primary-13: rgba(0, 0, 0, 0.13);\n$box-shadow-primary-12: rgba(0, 0, 0, 0.12);\n$box-shadow-primary-25: rgba(0, 0, 0, 0.25);\n$box-shadow-primary-19: rgba(0, 0, 0, 0.19);\n$box-shadow-primary-22: rgba(0, 0, 0, 0.22);\n$box-shadow-primary-57: rgba(0, 0, 0, 0.57);\n\n$card-view-box-shadow: 0 2px 6px 0 rgba(109,109,109,0.08);\n$card-view-box-shadow-hover: 0 3px 7px 0 rgba(109,109,109,0.5);\n\n$card-view-box-shadow-light: -1px 1px 8px rgba(0, 0, 0, 0.11);\n$card-view-box-shadow-light-hover:  -1px 1px 8px rgba(0, 0, 0, 0.28);\n\n.color-primary {\n  color: $primary-color-500;\n}\n\n.color-primary-700 {\n  color: $primary-color-700\n}\n","$screen-xs-min: 425px;\n$screen-sm-min: 576px;\n$screen-md-min: 768px;\n$screen-lg-min: 992px;\n$screen-xl-min: 1200px;\n\n// Mixins\n@mixin xs { @media (min-width: #{$screen-xs-min}) {@content;} }\n@mixin on-small { @media (max-width: #{$screen-sm-min}) {@content;} }\n@mixin up-small { @media (min-width: #{$screen-sm-min}) {@content;} }\n@mixin md { @media (min-width: #{$screen-md-min}) {@content;} }\n@mixin lg { @media (min-width: #{$screen-lg-min}) {@content;} }\n@mixin xl { @media (min-width: #{$screen-xl-min}) {@content;} }\n\n$z-index: (\n  close: -1,\n  modal      : 30,\n  navigation : 10,\n  dropdown: 12,\n  sticky-element: 18,\n  pop-up    : 20,\n  highest: 32\n);\n\n@function z-index($key) {\n  @return map-get($z-index, $key);\n}\n\n@mixin z-index($key) {\n  z-index: z-index($key);\n}\n\n@mixin breakpoint($class) {\n  @if $class == xsmall {\n    @media (max-width: 576px) { @content; }\n  }\n\n  @else if $class == small-down {\n    @media (max-width: 768px) { @content; }\n  }\n\n  @else if $class == mobile {\n    @media (min-width: 576px) { @content; }\n  }\n\n  @else if $class == small {\n    @media (min-width: 768px) { @content; }\n  }\n\n  @else if $class == medium-down {\n    @media (max-width: 992px) { @content; }\n  }\n\n  @else if $class == medium {\n    @media (min-width: 992px) { @content; }\n  }\n\n  @else if $class == large {\n    @media (min-width: 1200px) { @content; }\n  }\n\n  @else if $class == large-down {\n    @media (max-width: 1200px) { @content; }\n  }\n\n  @else if $class == xlarge {\n    @media (min-width: 1440px) { @content; }\n  }\n\n  @else if $class == xlarge-down {\n    @media (max-width: 1440px) { @content; }\n  }\n\n  @else if $class == xlarge-up {\n    @media (min-width: 1600px) { @content; }\n  }\n\n  @else if $class == 2k-down {\n    @media (min-width: 1800px) { @content; }\n  }\n\n  @else if $class == 2k-up {\n    @media (min-width: 1920px) { @content; }\n  }\n\n  @else if $class == 4k-down {\n    @media (min-width: 2500px) { @content; }\n  }\n\n  @else if $class == 4k {\n    @media (min-width: 3839px) { @content; }\n  }\n\n  @else if $class == 5k {\n    @media (min-width: 5100px) { @content; }\n  }\n\n  @else if $class == 5k-up {\n    @media (min-width: 5121px) { @content; }\n  }\n\n  @else {\n    @warn \"Breakpoint mixin supports: xs, sm, md, lg\";\n  }\n}\n\n@mixin prefix($prop, $value) {\n  -webkit-#{$prop}: #{$value};\n  -moz-#{$prop}: #{$value};\n  -ms-#{$prop}: #{$value};\n  -o-#{$prop}: #{$value};\n  #{$prop}: #{$value};\n}\n\n@mixin keyframes($name) {\n  @-webkit-keyframes #{$name} {\n    @content;\n  }\n\n  @-moz-keyframes #{$name} {\n    @content;\n  }\n\n  @keyframes #{$name} {\n    @content;\n  }\n}\n\n$max: 100;\n$offset: 1;\n$unit: 'px';\n@mixin list-loop($className, $styleName) {\n  $i: 0;\n  @while $i <= $max {\n    #{$className + $i} {\n      #{$styleName}: #{$i + $unit};\n    }\n    $i: $i + $offset;\n  }\n}\n\n@include list-loop('.padding-l-', 'padding-left');\n@include list-loop('.padding-r-', 'padding-right');\n@include list-loop('.padding-b-', 'padding-bottom');\n@include list-loop('.padding-t-', 'padding-top');\n@include list-loop('.margin-l-', 'margin-left');\n@include list-loop('.margin-r-', 'margin-right');\n@include list-loop('.margin-b-', 'margin-bottom');\n@include list-loop('.margin-t-', 'margin-top');\n\n@mixin ScaleDownFromCenter {\n  @include animation(0, .3s, openScaleDownFromCenter, normal, 1, forwards);\n}\n\n@mixin closeScaleUpFromCenter {\n  @include animation(0, .3s, closeScaleUpFromCenter, normal, 1, forwards);\n}\n\n@include keyframes(closeScaleUpFromCenter) {\n  0% {\n    z-index: 4001;\n    opacity: 1;\n    teansform: scale(1);\n  }\n\n  100% {\n    transform: scale(1.3);\n    opacity: 0;\n    z-index: -10;\n  }\n}\n\n\n@include keyframes(openScaleDownFromCenter) {\n  0% {\n    opacity: 0.5;\n    teansform: scale(1.4);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@mixin animation ($delay, $duration, $animation, $direction, $iteration, $fillmode) {\n  animation-name: $animation;\n  -o-animation-name: $animation;\n  -moz-animation-name: $animation;\n  -webkit-animation-name: $animation;\n\n    animation-delay: $delay;\n  -o-animation-delay: $delay;\n  -moz-animation-delay: $delay;\n  -webkit-animation-delay: $delay;\n\n    animation-duration: $duration;\n  -o-animation-duration: $duration;\n  -moz-animation-duration: $duration;\n  -webkit-animation-duration: $duration;\n\n    animation-fill-mode: $fillmode;\n  -o-animation-fill-mode: $fillmode;\n  -moz-animation-fill-mode: $fillmode;\n  -webkit-animation-fill-mode: $fillmode;\n\n    animation-direction: $direction;\n  -o-animation-direction: $direction;\n  -moz-animation-direction: $direction;\n  -webkit-animation-direction: $direction;\n\n    animation-iteration-count: $iteration;\n  -o-animation-iteration-count: $iteration;\n  -moz-animation-iteration-count: $iteration;\n  -webkit-animation-iteration-count: $iteration;\n}\n\n@mixin sourcesButton {\n  @include prefix(display, flex);\n  @include prefix(flex-flow, row);\n  @include prefix(align-items, center);\n  @include prefix(justify-content, flex-end);\n  width: 100%;\n\n  &__item {\n    border: 1px solid $primary-color-500;\n    border-radius: 20px;\n    background-color: $primary-color-light-500;;\n    box-shadow: 0 2px 4px 0 $box-shadow-primary-5;\n    color: $primary-color-500;\n    border: 1px solid $primary-color-500;\n    font-family: $primary-font;\n    font-size: 11px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 15px;\n    padding: 5px 15px;\n    margin-top: 0;\n    cursor: pointer;\n    margin-left: 10px;\n\n    @include breakpoint(medium) { \n      font-size: 11px;\n      font-weight: 500;\n      padding: 7px 20px;\n    }\n\n    &[disabled] {\n      cursor: default;\n      pointer-events: none;\n      opacity: .6;\n      background-color: $primary-color-dark-100;\n    }\n\n    &.selected {\n      color: $primary-color-light-500;\n      border: 1px solid $primary-color-500;\n      border-radius: 20px;\n      background-color: $primary-color-500;\n      box-shadow: 0 2px 4px 0 $box-shadow-primary-5;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
